/* global document */
const api = {};

api.helpers = {};

api.helpers.page = (page, size, axiosConfig) => {
  if (utils.isNullOrUndefined(axiosConfig)) {
    console.log('axios config is null');
    return;
  }

  if (utils.isNullOrUndefined(axiosConfig.params)) {
    axiosConfig.params = {};
  }

  axiosConfig.params.paging = {
    num: page,
    size: size
  };

  // technically don't need to return it, the object is already updated
  // doing it as more of a pass through
  return axiosConfig;
};

api.helpers.logErrorObject = (error) => {
  // console.log(error);
  if (!utils.isNullOrUndefined(error.response) &&
    error.response.status === 400) {
    console.log(error.response.data);
  } else {
    console.error(error);
  }
};

api.helpers.complexParams = (axiosConfig) => {
  const ob = axiosConfig.params || {};
  const params = {};
  for (const key in ob) {
    if (!ob.hasOwnProperty(key)) {
      continue;
    }
    const value = ob[key];
    if (value instanceof Array) {
      
    } else if (value instanceof Object) {
      for (const subKey in value) {
        if (!value.hasOwnProperty(subKey)) {
          continue;
        }
        const newKey = `${key}[${subKey}]`;
        params[newKey] = value[subKey];
      }
    } else {
      params[key] = value;
    }
  }

  axiosConfig.params = params;
  return axiosConfig;
};

api.helpers.JWT_COOKIE_NAME = 'jwt_token_vzw';
api.helpers.XSRF_COOKIE_NAME = 'X-XSRF';
class Authenticated {
  constructor() {
    const token = Cookies.get(api.helpers.JWT_COOKIE_NAME);

    this.returnUrl = encodeURIComponent(window.location.pathname.substring(1));
    this.authUrl = `/signin?r=${this.returnUrl}`;
    this.signoutUrl = '/signout';

    if (window.location.pathname !== '/login') {
      if (utils.isNullOrUndefined(token)) {
        window.location = this.authUrl;
        return;
      }
    }
  }

  hasPermCode(code) {
    const perms = this.getUser().perms.split('|');
    return perms.some(p => p.toLowerCase() === code.toLowerCase());
  }

  redirectToLogin() {
    if (window.location.pathname !== '/login') {
        window.location = this.authUrl;
    }
  }

  redirectToLogout() {
    window.location = this.signoutUrl;
  }

  redirectToAdmin() {
    window.open('/admin', '_blank');
  }

  setTokenCookie(token) {
    Cookies.set(api.helpers.JWT_COOKIE_NAME, token);
  }

  getUser() {
    const token = Cookies.get(api.helpers.JWT_COOKIE_NAME);

    if (utils.isNullOrUndefined(token)) {
      console.error('No user available');
      this.redirectToLogin();
      return;
    }

    const jwtParts = token.split('.');
    const payload = jwtParts[1];

    const decoded = window.atob(payload);
    const tokenObj = JSON.parse(decoded);

    return {
      jti: tokenObj.jti,
      currentTenant: tokenObj.txref,
      firstName: tokenObj.fname,
      lastName: tokenObj.lname,
      email: tokenObj.email,
      // add in perm group cat for a more corse check (like admin button)
      perms: `${tokenObj.pgcodes  }|${  tokenObj.pgcat.toLowerCase()}`
    };
  }

  signout() {
    // TODO: redirect to /logout (handle in express)
    Cookies.remove(api.helpers.JWT_COOKIE_NAME, '');
    this.redirectToLogout();
  }

  authReq(axiosConfig) {
    const jwtName = api.helpers.JWT_COOKIE_NAME;
    const token = Cookies.get(jwtName);

    let hasError = false;
    if (utils.isNullOrUndefined(token)) {
      console.error(`Can't find ${jwtName} cookie`);
      hasError = true;
    } 

    if (hasError) {
      this.redirectToLogin();
      return;
    }

    axiosConfig.headers = axiosConfig.headers || {};

    // currently applying the authorization on the server
    // axiosConfig.headers['Authorization'] = `Bearer ${token}`;
    const datestamp = `?${  Date.now()}`;
    const newConfig = api.helpers.complexParams(axiosConfig);
    newConfig.url += datestamp;
    const req = axios(newConfig);

    // TODO: need to allow error to bubble up so it can be handled at higher levels
    req.catch(error => {
      if (!utils.isNullOrUndefined(error.response)) {
        if (error.response.status === 401) {
          // Probably needs to be more graceful than this
          this.signout();
          return;
        }
      } 
    });

    return req;
  }
}
//! moment.js
//! version : 2.8.3
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

(function(undefined) {
    /************************************
        Constants
    ************************************/

    var moment,
        VERSION = '2.8.3',
        // the global-scope this is NOT the global object in Node.js
        globalScope = typeof global !== 'undefined' ? global : this,
        oldGlobalMoment,
        round = Math.round,
        hasOwnProperty = Object.prototype.hasOwnProperty,
        i,

        YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,

        // internal storage for locale config files
        locales = {},

        // extra moment internal properties (plugins register props here)
        momentProperties = [],

        // check for nodeJS
        hasModule = (typeof module !== 'undefined' && module.exports),

        // ASP.NET json date format regex
        aspNetJsonRegex = /^\/?Date\((\-?\d+)/i,
        aspNetTimeSpanJsonRegex = /(\-)?(?:(\d*)\.)?(\d+)\:(\d+)(?:\:(\d+)\.?(\d{3})?)?/,

        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        isoDurationRegex = /^(-)?P(?:(?:([0-9,.]*)Y)?(?:([0-9,.]*)M)?(?:([0-9,.]*)D)?(?:T(?:([0-9,.]*)H)?(?:([0-9,.]*)M)?(?:([0-9,.]*)S)?)?|([0-9,.]*)W)$/,

        // format tokens
        formattingTokens = /(\[[^\[]*\])|(\\)?(Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Q|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|mm?|ss?|S{1,4}|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LT|LL?L?L?|l{1,4})/g,

        // parsing token regexes
        parseTokenOneOrTwoDigits = /\d\d?/, // 0 - 99
        parseTokenOneToThreeDigits = /\d{1,3}/, // 0 - 999
        parseTokenOneToFourDigits = /\d{1,4}/, // 0 - 9999
        parseTokenOneToSixDigits = /[+\-]?\d{1,6}/, // -999,999 - 999,999
        parseTokenDigits = /\d+/, // nonzero number of digits
        parseTokenWord = /[0-9]*['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+|[\u0600-\u06FF\/]+(\s*?[\u0600-\u06FF]+){1,2}/i, // any word (or two) characters or numbers including two/three word month in arabic.
        parseTokenTimezone = /Z|[\+\-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        parseTokenT = /T/i, // T (ISO separator)
        parseTokenTimestampMs = /[\+\-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        parseTokenOrdinal = /\d{1,2}/,

        //strict parsing regexes
        parseTokenOneDigit = /\d/, // 0 - 9
        parseTokenTwoDigits = /\d\d/, // 00 - 99
        parseTokenThreeDigits = /\d{3}/, // 000 - 999
        parseTokenFourDigits = /\d{4}/, // 0000 - 9999
        parseTokenSixDigits = /[+-]?\d{6}/, // -999,999 - 999,999
        parseTokenSignedNumber = /[+-]?\d+/, // -inf - inf

        // iso 8601 regex
        // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
        isoRegex = /^\s*(?:[+-]\d{6}|\d{4})-(?:(\d\d-\d\d)|(W\d\d$)|(W\d\d-\d)|(\d\d\d))((T| )(\d\d(:\d\d(:\d\d(\.\d+)?)?)?)?([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/,

        isoFormat = 'YYYY-MM-DDTHH:mm:ssZ',

        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d{2}-\d{2}/],
            ['YYYY-MM-DD', /\d{4}-\d{2}-\d{2}/],
            ['GGGG-[W]WW-E', /\d{4}-W\d{2}-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d{2}/],
            ['YYYY-DDD', /\d{4}-\d{3}/]
        ],

        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /(T| )\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss', /(T| )\d\d:\d\d:\d\d/],
            ['HH:mm', /(T| )\d\d:\d\d/],
            ['HH', /(T| )\d\d/]
        ],

        // timezone chunker '+10:00' > ['10', '00'] or '-1530' > ['-15', '30']
        parseTimezoneChunker = /([\+\-]|\d\d)/gi,

        // getter and setter names
        proxyGettersAndSetters = 'Date|Hours|Minutes|Seconds|Milliseconds'.split('|'),
        unitMillisecondFactors = {
            'Milliseconds': 1,
            'Seconds': 1e3,
            'Minutes': 6e4,
            'Hours': 36e5,
            'Days': 864e5,
            'Months': 2592e6,
            'Years': 31536e6
        },

        unitAliases = {
            ms: 'millisecond',
            s: 'second',
            m: 'minute',
            h: 'hour',
            d: 'day',
            D: 'date',
            w: 'week',
            W: 'isoWeek',
            M: 'month',
            Q: 'quarter',
            y: 'year',
            DDD: 'dayOfYear',
            e: 'weekday',
            E: 'isoWeekday',
            gg: 'weekYear',
            GG: 'isoWeekYear'
        },

        camelFunctions = {
            dayofyear: 'dayOfYear',
            isoweekday: 'isoWeekday',
            isoweek: 'isoWeek',
            weekyear: 'weekYear',
            isoweekyear: 'isoWeekYear'
        },

        // format function strings
        formatFunctions = {},

        // default relative time thresholds
        relativeTimeThresholds = {
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month
            M: 11 // months to year
        },

        // tokens to ordinalize and pad
        ordinalizeTokens = 'DDD w W M D d'.split(' '),
        paddedTokens = 'M D H h m s w W'.split(' '),

        formatTokenFunctions = {
            M: function() {
                return this.month() + 1;
            },
            MMM: function(format) {
                return this.localeData().monthsShort(this, format);
            },
            MMMM: function(format) {
                return this.localeData().months(this, format);
            },
            D: function() {
                return this.date();
            },
            DDD: function() {
                return this.dayOfYear();
            },
            d: function() {
                return this.day();
            },
            dd: function(format) {
                return this.localeData().weekdaysMin(this, format);
            },
            ddd: function(format) {
                return this.localeData().weekdaysShort(this, format);
            },
            dddd: function(format) {
                return this.localeData().weekdays(this, format);
            },
            w: function() {
                return this.week();
            },
            W: function() {
                return this.isoWeek();
            },
            YY: function() {
                return leftZeroFill(this.year() % 100, 2);
            },
            YYYY: function() {
                return leftZeroFill(this.year(), 4);
            },
            YYYYY: function() {
                return leftZeroFill(this.year(), 5);
            },
            YYYYYY: function() {
                var y = this.year(), sign = y >= 0 ? '+' : '-';
                return sign + leftZeroFill(Math.abs(y), 6);
            },
            gg: function() {
                return leftZeroFill(this.weekYear() % 100, 2);
            },
            gggg: function() {
                return leftZeroFill(this.weekYear(), 4);
            },
            ggggg: function() {
                return leftZeroFill(this.weekYear(), 5);
            },
            GG: function() {
                return leftZeroFill(this.isoWeekYear() % 100, 2);
            },
            GGGG: function() {
                return leftZeroFill(this.isoWeekYear(), 4);
            },
            GGGGG: function() {
                return leftZeroFill(this.isoWeekYear(), 5);
            },
            e: function() {
                return this.weekday();
            },
            E: function() {
                return this.isoWeekday();
            },
            a: function() {
                return this.localeData().meridiem(this.hours(), this.minutes(), true);
            },
            A: function() {
                return this.localeData().meridiem(this.hours(), this.minutes(), false);
            },
            H: function() {
                return this.hours();
            },
            h: function() {
                return this.hours() % 12 || 12;
            },
            m: function() {
                return this.minutes();
            },
            s: function() {
                return this.seconds();
            },
            S: function() {
                return toInt(this.milliseconds() / 100);
            },
            SS: function() {
                return leftZeroFill(toInt(this.milliseconds() / 10), 2);
            },
            SSS: function() {
                return leftZeroFill(this.milliseconds(), 3);
            },
            SSSS: function() {
                return leftZeroFill(this.milliseconds(), 3);
            },
            Z: function() {
                var a = -this.zone(),
                    b = '+';
                if (a < 0) {
                    a = -a;
                    b = '-';
                }
                return b + leftZeroFill(toInt(a / 60), 2) + ':' + leftZeroFill(toInt(a) % 60, 2);
            },
            ZZ: function() {
                var a = -this.zone(),
                    b = '+';
                if (a < 0) {
                    a = -a;
                    b = '-';
                }
                return b + leftZeroFill(toInt(a / 60), 2) + leftZeroFill(toInt(a) % 60, 2);
            },
            z: function() {
                return this.zoneAbbr();
            },
            zz: function() {
                return this.zoneName();
            },
            X: function() {
                return this.unix();
            },
            Q: function() {
                return this.quarter();
            }
        },

        deprecations = {},

        lists = ['months', 'monthsShort', 'weekdays', 'weekdaysShort', 'weekdaysMin'];

    // Pick the first defined of two or three arguments. dfl comes from
    // default.
    function dfl(a, b, c) {
        switch (arguments.length) {
        case 2:
            return a != null ? a : b;
        case 3:
            return a != null ? a : b != null ? b : c;
        default:
            throw new Error('Implement me');
        }
    }

    function hasOwnProp(a, b) {
        return hasOwnProperty.call(a, b);
    }

    function defaultParsingFlags() {
        // We need to deep clone this object, and es5 standard is not very
        // helpful.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false
        };
    }

    function printMsg(msg) {
        if (moment.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (firstTime) {
                printMsg(msg);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    function deprecateSimple(name, msg) {
        if (!deprecations[name]) {
            printMsg(msg);
            deprecations[name] = true;
        }
    }

    function padToken(func, count) {
        return function(a) {
            return leftZeroFill(func.call(this, a), count);
        };
    }

    function ordinalizeToken(func, period) {
        return function(a) {
            return this.localeData().ordinal(func.call(this, a), period);
        };
    }

    while (ordinalizeTokens.length) {
        i = ordinalizeTokens.pop();
        formatTokenFunctions[i + 'o'] = ordinalizeToken(formatTokenFunctions[i], i);
    }
    while (paddedTokens.length) {
        i = paddedTokens.pop();
        formatTokenFunctions[i + i] = padToken(formatTokenFunctions[i], 2);
    }
    formatTokenFunctions.DDDD = padToken(formatTokenFunctions.DDD, 3);


    /************************************
        Constructors
    ************************************/

    function Locale() {
    }

    // Moment prototype object
    function Moment(config, skipOverflow) {
        if (skipOverflow !== false) {
            checkOverflow(config);
        }
        copyConfig(this, config);
        this._d = new Date(+config._d);
    }

    // Duration Constructor
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 36e5; // 1000 * 60 * 60
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = moment.localeData();

        this._bubble();
    }

    /************************************
        Helpers
    ************************************/


    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function copyConfig(to, from) {
        var i, prop, val;

        if (typeof from._isAMomentObject !== 'undefined') {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (typeof from._i !== 'undefined') {
            to._i = from._i;
        }
        if (typeof from._f !== 'undefined') {
            to._f = from._f;
        }
        if (typeof from._l !== 'undefined') {
            to._l = from._l;
        }
        if (typeof from._strict !== 'undefined') {
            to._strict = from._strict;
        }
        if (typeof from._tzm !== 'undefined') {
            to._tzm = from._tzm;
        }
        if (typeof from._isUTC !== 'undefined') {
            to._isUTC = from._isUTC;
        }
        if (typeof from._offset !== 'undefined') {
            to._offset = from._offset;
        }
        if (typeof from._pf !== 'undefined') {
            to._pf = from._pf;
        }
        if (typeof from._locale !== 'undefined') {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i in momentProperties) {
                prop = momentProperties[i];
                val = from[prop];
                if (typeof val !== 'undefined') {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.ceil(number);
        } else {
            return Math.floor(number);
        }
    }

    // left zero fill a number
    // see http://jsperf.com/left-zero-filling for performance comparison
    function leftZeroFill(number, targetLength, forceSign) {
        var output = '' + Math.abs(number),
            sign = number >= 0;

        while (output.length < targetLength) {
            output = '0' + output;
        }
        return (sign ? (forceSign ? '+' : '') : '-') + output;
    }

    function positiveMomentsDifference(base, other) {
        var res = { milliseconds: 0, months: 0 };

        res.months = other.month() - base.month() +
        (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        other = makeAs(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period).');
                tmp = val;
                val = period;
                period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = moment.duration(val, period);
            addOrSubtractDurationFromMoment(this, dur, direction);
            return this;
        };
    }

    function addOrSubtractDurationFromMoment(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = duration._days,
            months = duration._months;
        updateOffset = updateOffset == null ? true : updateOffset;

        if (milliseconds) {
            mom._d.setTime(+mom._d + milliseconds * isAdding);
        }
        if (days) {
            rawSetter(mom, 'Date', rawGetter(mom, 'Date') + days * isAdding);
        }
        if (months) {
            rawMonthSetter(mom, rawGetter(mom, 'Month') + months * isAdding);
        }
        if (updateOffset) {
            moment.updateOffset(mom, days || months);
        }
    }

    // check if is an array
    function isArray(input) {
        return Object.prototype.toString.call(input) === '[object Array]';
    }

    function isDate(input) {
        return Object.prototype.toString.call(input) === '[object Date]' ||
            input instanceof Date;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
            (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function normalizeUnits(units) {
        if (units) {
            var lowered = units.toLowerCase().replace(/(.)s$/, '$1');
            units = unitAliases[units] || camelFunctions[lowered] || lowered;
        }
        return units;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    function makeList(field) {
        var count, setter;

        if (field.indexOf('week') === 0) {
            count = 7;
            setter = 'day';
        } else if (field.indexOf('month') === 0) {
            count = 12;
            setter = 'month';
        } else {
            return;
        }

        moment[field] = function(format, index) {
            var i,
                getter,
                method = moment._locale[field],
                results = [];

            if (typeof format === 'number') {
                index = format;
                format = undefined;
            }

            getter = function(i) {
                var m = moment().utc().set(setter, i);
                return method.call(moment._locale, m, format || '');
            };

            if (index != null) {
                return getter(index);
            } else {
                for (i = 0; i < count; i++) {
                    results.push(getter(i));
                }
                return results;
            }
        };
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            if (coercedNumber >= 0) {
                value = Math.floor(coercedNumber);
            } else {
                value = Math.ceil(coercedNumber);
            }
        }

        return value;
    }

    function daysInMonth(year, month) {
        return new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
    }

    function weeksInYear(year, dow, doy) {
        return weekOfYear(moment([year, 11, 31 + dow - doy]), dow, doy).week;
    }

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function checkOverflow(m) {
        var overflow;
        if (m._a && m._pf.overflow === -2) {
            overflow =
                m._a[MONTH] < 0 || m._a[MONTH] > 11 ? MONTH :
                m._a[DATE] < 1 || m._a[DATE] > daysInMonth(m._a[YEAR], m._a[MONTH]) ? DATE :
                m._a[HOUR] < 0 || m._a[HOUR] > 23 ? HOUR :
                m._a[MINUTE] < 0 || m._a[MINUTE] > 59 ? MINUTE :
                m._a[SECOND] < 0 || m._a[SECOND] > 59 ? SECOND :
                m._a[MILLISECOND] < 0 || m._a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (m._pf._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }

            m._pf.overflow = overflow;
        }
    }

    function isValid(m) {
        if (m._isValid == null) {
            m._isValid = !isNaN(m._d.getTime()) &&
                m._pf.overflow < 0 &&
                !m._pf.empty &&
                !m._pf.invalidMonth &&
                !m._pf.nullInput &&
                !m._pf.invalidFormat &&
                !m._pf.userInvalidated;

            if (m._strict) {
                m._isValid = m._isValid &&
                    m._pf.charsLeftOver === 0 &&
                    m._pf.unusedTokens.length === 0;
            }
        }
        return m._isValid;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return null;
    }

    function loadLocale(name) {
        var oldLocale = null;
        if (!locales[name] && hasModule) {
            try {
                oldLocale = moment.locale();
                require('./locale/' + name);
                // because defineLocale currently also sets the global locale, we want to undo that for lazy loaded locales
                moment.locale(oldLocale);
            } catch (e) {
            }
        }
        return locales[name];
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function makeAs(input, model) {
        return model._isUTC ? moment(input).zone(model._offset || 0) :
            moment(input).local();
    }

    /************************************
        Locale
    ************************************/


    extend(Locale.prototype, {
        set: function(config) {
            var prop, i;
            for (i in config) {
                prop = config[i];
                if (typeof prop === 'function') {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        },

        _months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
        months: function(m) {
            return this._months[m.month()];
        },

        _monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        monthsShort: function(m) {
            return this._monthsShort[m.month()];
        },

        monthsParse: function(monthName) {
            var i, mom, regex;

            if (!this._monthsParse) {
                this._monthsParse = [];
            }

            for (i = 0; i < 12; i++) {
                // make the regex if we don't have it already
                if (!this._monthsParse[i]) {
                    mom = moment.utc([2000, i]);
                    regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._monthsParse[i].test(monthName)) {
                    return i;
                }
            }
        },

        _weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        weekdays: function(m) {
            return this._weekdays[m.day()];
        },

        _weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysShort: function(m) {
            return this._weekdaysShort[m.day()];
        },

        _weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        weekdaysMin: function(m) {
            return this._weekdaysMin[m.day()];
        },

        weekdaysParse: function(weekdayName) {
            var i, mom, regex;

            if (!this._weekdaysParse) {
                this._weekdaysParse = [];
            }

            for (i = 0; i < 7; i++) {
                // make the regex if we don't have it already
                if (!this._weekdaysParse[i]) {
                    mom = moment([2000, 1]).day(i);
                    regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                // test the regex
                if (this._weekdaysParse[i].test(weekdayName)) {
                    return i;
                }
            }
        },

        _longDateFormat: {
            LT: 'h:mm A',
            L: 'MM/DD/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY LT',
            LLLL: 'dddd, MMMM D, YYYY LT'
        },
        longDateFormat: function(key) {
            var output = this._longDateFormat[key];
            if (!output && this._longDateFormat[key.toUpperCase()]) {
                output = this._longDateFormat[key.toUpperCase()].replace(/MMMM|MM|DD|dddd/g, function(val) {
                    return val.slice(1);
                });
                this._longDateFormat[key] = output;
            }
            return output;
        },

        isPM: function(input) {
            // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
            // Using charAt should be more compatible.
            return ((input + '').toLowerCase().charAt(0) === 'p');
        },

        _meridiemParse: /[ap]\.?m?\.?/i,
        meridiem: function(hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'pm' : 'PM';
            } else {
                return isLower ? 'am' : 'AM';
            }
        },

        _calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        },
        calendar: function(key, mom) {
            var output = this._calendar[key];
            return typeof output === 'function' ? output.apply(mom) : output;
        },

        _relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        },

        relativeTime: function(number, withoutSuffix, string, isFuture) {
            var output = this._relativeTime[string];
            return (typeof output === 'function') ?
                output(number, withoutSuffix, string, isFuture) :
                output.replace(/%d/i, number);
        },

        pastFuture: function(diff, output) {
            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
            return typeof format === 'function' ? format(output) : format.replace(/%s/i, output);
        },

        ordinal: function(number) {
            return this._ordinal.replace('%d', number);
        },
        _ordinal: '%d',

        preparse: function(string) {
            return string;
        },

        postformat: function(string) {
            return string;
        },

        week: function(mom) {
            return weekOfYear(mom, this._week.dow, this._week.doy).week;
        },

        _week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6 // The week that contains Jan 1st is the first week of the year.
        },

        _invalidDate: 'Invalid date',
        invalidDate: function() {
            return this._invalidDate;
        }
    });

    /************************************
        Formatting
    ************************************/


    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function(mom) {
            var output = '';
            for (i = 0; i < length; i++) {
                output += array[i] instanceof Function ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());

        if (!formatFunctions[format]) {
            formatFunctions[format] = makeFormatFunction(format);
        }

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }


    /************************************
        Parsing
    ************************************/


    // get the regex to find the next token
    function getParseRegexForToken(token, config) {
        var a, strict = config._strict;
        switch (token) {
        case 'Q':
            return parseTokenOneDigit;
        case 'DDDD':
            return parseTokenThreeDigits;
        case 'YYYY':
        case 'GGGG':
        case 'gggg':
            return strict ? parseTokenFourDigits : parseTokenOneToFourDigits;
        case 'Y':
        case 'G':
        case 'g':
            return parseTokenSignedNumber;
        case 'YYYYYY':
        case 'YYYYY':
        case 'GGGGG':
        case 'ggggg':
            return strict ? parseTokenSixDigits : parseTokenOneToSixDigits;
        case 'S':
            if (strict) {
                return parseTokenOneDigit;
            }
        /* falls through */
        case 'SS':
            if (strict) {
                return parseTokenTwoDigits;
            }
        /* falls through */
        case 'SSS':
            if (strict) {
                return parseTokenThreeDigits;
            }
        /* falls through */
        case 'DDD':
            return parseTokenOneToThreeDigits;
        case 'MMM':
        case 'MMMM':
        case 'dd':
        case 'ddd':
        case 'dddd':
            return parseTokenWord;
        case 'a':
        case 'A':
            return config._locale._meridiemParse;
        case 'X':
            return parseTokenTimestampMs;
        case 'Z':
        case 'ZZ':
            return parseTokenTimezone;
        case 'T':
            return parseTokenT;
        case 'SSSS':
            return parseTokenDigits;
        case 'MM':
        case 'DD':
        case 'YY':
        case 'GG':
        case 'gg':
        case 'HH':
        case 'hh':
        case 'mm':
        case 'ss':
        case 'ww':
        case 'WW':
            return strict ? parseTokenTwoDigits : parseTokenOneOrTwoDigits;
        case 'M':
        case 'D':
        case 'd':
        case 'H':
        case 'h':
        case 'm':
        case 's':
        case 'w':
        case 'W':
        case 'e':
        case 'E':
            return parseTokenOneOrTwoDigits;
        case 'Do':
            return parseTokenOrdinal;
        default:
            a = new RegExp(regexpEscape(unescapeFormat(token.replace('\\', '')), 'i'));
            return a;
        }
    }

    function timezoneMinutesFromString(string) {
        string = string || '';
        var possibleTzMatches = (string.match(parseTokenTimezone) || []),
            tzChunk = possibleTzMatches[possibleTzMatches.length - 1] || [],
            parts = (tzChunk + '').match(parseTimezoneChunker) || ['-', 0, 0],
            minutes = +(parts[1] * 60) + toInt(parts[2]);

        return parts[0] === '+' ? -minutes : minutes;
    }

    // function to convert string input to date
    function addTimeToArrayFromToken(token, input, config) {
        var a, datePartArray = config._a;

        switch (token) {
            // QUARTER
        case 'Q':
            if (input != null) {
                datePartArray[MONTH] = (toInt(input) - 1) * 3;
            }
            break;
        // MONTH
        case 'M': // fall through to MM
        case 'MM':
            if (input != null) {
                datePartArray[MONTH] = toInt(input) - 1;
            }
            break;
        case 'MMM': // fall through to MMMM
        case 'MMMM':
            a = config._locale.monthsParse(input);
            // if we didn't find a month name, mark the date as invalid.
            if (a != null) {
                datePartArray[MONTH] = a;
            } else {
                config._pf.invalidMonth = input;
            }
            break;
        // DAY OF MONTH
        case 'D': // fall through to DD
        case 'DD':
            if (input != null) {
                datePartArray[DATE] = toInt(input);
            }
            break;
        case 'Do':
            if (input != null) {
                datePartArray[DATE] = toInt(parseInt(input, 10));
            }
            break;
        // DAY OF YEAR
        case 'DDD': // fall through to DDDD
        case 'DDDD':
            if (input != null) {
                config._dayOfYear = toInt(input);
            }

            break;
        // YEAR
        case 'YY':
            datePartArray[YEAR] = moment.parseTwoDigitYear(input);
            break;
        case 'YYYY':
        case 'YYYYY':
        case 'YYYYYY':
            datePartArray[YEAR] = toInt(input);
            break;
        // AM / PM
        case 'a': // fall through to A
        case 'A':
            config._isPm = config._locale.isPM(input);
            break;
        // 24 HOUR
        case 'H': // fall through to hh
        case 'HH': // fall through to hh
        case 'h': // fall through to hh
        case 'hh':
            datePartArray[HOUR] = toInt(input);
            break;
        // MINUTE
        case 'm': // fall through to mm
        case 'mm':
            datePartArray[MINUTE] = toInt(input);
            break;
        // SECOND
        case 's': // fall through to ss
        case 'ss':
            datePartArray[SECOND] = toInt(input);
            break;
        // MILLISECOND
        case 'S':
        case 'SS':
        case 'SSS':
        case 'SSSS':
            datePartArray[MILLISECOND] = toInt(('0.' + input) * 1000);
            break;
        // UNIX TIMESTAMP WITH MS
        case 'X':
            config._d = new Date(parseFloat(input) * 1000);
            break;
        // TIMEZONE
        case 'Z': // fall through to ZZ
        case 'ZZ':
            config._useUTC = true;
            config._tzm = timezoneMinutesFromString(input);
            break;
        // WEEKDAY - human
        case 'dd':
        case 'ddd':
        case 'dddd':
            a = config._locale.weekdaysParse(input);
            // if we didn't get a weekday name, mark the date as invalid
            if (a != null) {
                config._w = config._w || {};
                config._w['d'] = a;
            } else {
                config._pf.invalidWeekday = input;
            }
            break;
        // WEEK, WEEK DAY - numeric
        case 'w':
        case 'ww':
        case 'W':
        case 'WW':
        case 'd':
        case 'e':
        case 'E':
            token = token.substr(0, 1);
        /* falls through */
        case 'gggg':
        case 'GGGG':
        case 'GGGGG':
            token = token.substr(0, 2);
            if (input) {
                config._w = config._w || {};
                config._w[token] = toInt(input);
            }
            break;
        case 'gg':
        case 'GG':
            config._w = config._w || {};
            config._w[token] = moment.parseTwoDigitYear(input);
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = dfl(w.GG, config._a[YEAR], weekOfYear(moment(), 1, 4).year);
            week = dfl(w.W, 1);
            weekday = dfl(w.E, 1);
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            weekYear = dfl(w.gg, config._a[YEAR], weekOfYear(moment(), dow, doy).year);
            week = dfl(w.w, 1);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < dow) {
                    ++week;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from begining of week
                weekday = w.e + dow;
            } else {
                // default to begining of week
                weekday = dow;
            }
        }
        temp = dayOfYearFromWeeks(weekYear, week, weekday, doy, dow);

        config._a[YEAR] = temp.year;
        config._dayOfYear = temp.dayOfYear;
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function dateFromConfig(config) {
        var i, date, input = [], currentDate, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear) {
            yearToUse = dfl(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse)) {
                config._pf._overflowDayOfYear = true;
            }

            date = makeUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        config._d = (config._useUTC ? makeUTCDate : makeDate).apply(null, input);
        // Apply timezone offset from input. The actual zone can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() + config._tzm);
        }
    }

    function dateFromObject(config) {
        var normalizedInput;

        if (config._d) {
            return;
        }

        normalizedInput = normalizeObjectUnits(config._i);
        config._a = [
            normalizedInput.year,
            normalizedInput.month,
            normalizedInput.day,
            normalizedInput.hour,
            normalizedInput.minute,
            normalizedInput.second,
            normalizedInput.millisecond
        ];

        dateFromConfig(config);
    }

    function currentDateArray(config) {
        var now = new Date();
        if (config._useUTC) {
            return [
                now.getUTCFullYear(),
                now.getUTCMonth(),
                now.getUTCDate()
            ];
        } else {
            return [now.getFullYear(), now.getMonth(), now.getDate()];
        }
    }

    // date from string and format string
    function makeDateFromStringAndFormat(config) {
        if (config._f === moment.ISO_8601) {
            parseISO(config);
            return;
        }

        config._a = [];
        config._pf.empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    config._pf.unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    config._pf.empty = false;
                } else {
                    config._pf.unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                config._pf.unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        config._pf.charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            config._pf.unusedInput.push(string);
        }

        // handle am pm
        if (config._isPm && config._a[HOUR] < 12) {
            config._a[HOUR] += 12;
        }
        // if is 12 am, change hours to 0
        if (config._isPm === false && config._a[HOUR] === 12) {
            config._a[HOUR] = 0;
        }

        dateFromConfig(config);
        checkOverflow(config);
    }

    function unescapeFormat(s) {
        return s.replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        });
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function regexpEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    // date from string and array of format strings
    function makeDateFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            config._pf.invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._pf = defaultParsingFlags();
            tempConfig._f = config._f[i];
            makeDateFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += tempConfig._pf.charsLeftOver;

            //or tokens
            currentScore += tempConfig._pf.unusedTokens.length * 10;

            tempConfig._pf.score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    // date from iso format
    function parseISO(config) {
        var i,
            l,
            string = config._i,
            match = isoRegex.exec(string);

        if (match) {
            config._pf.iso = true;
            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(string)) {
                    // match[5] should be 'T' or undefined
                    config._f = isoDates[i][0] + (match[6] || ' ');
                    break;
                }
            }
            for (i = 0, l = isoTimes.length; i < l; i++) {
                if (isoTimes[i][1].exec(string)) {
                    config._f += isoTimes[i][0];
                    break;
                }
            }
            if (string.match(parseTokenTimezone)) {
                config._f += 'Z';
            }
            makeDateFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function makeDateFromString(config) {
        parseISO(config);
        if (config._isValid === false) {
            delete config._isValid;
            moment.createFromInputFallback(config);
        }
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function makeDateFromInput(config) {
        var input = config._i, matched;
        if (input === undefined) {
            config._d = new Date();
        } else if (isDate(input)) {
            config._d = new Date(+input);
        } else if ((matched = aspNetJsonRegex.exec(input)) !== null) {
            config._d = new Date(+matched[1]);
        } else if (typeof input === 'string') {
            makeDateFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            dateFromConfig(config);
        } else if (typeof(input) === 'object') {
            dateFromObject(config);
        } else if (typeof(input) === 'number') {
            // from milliseconds
            config._d = new Date(input);
        } else {
            moment.createFromInputFallback(config);
        }
    }

    function makeDate(y, m, d, h, M, s, ms) {
        //can't just apply() to create a date:
        //http://stackoverflow.com/questions/181348/instantiating-a-javascript-object-by-calling-prototype-constructor-apply
        var date = new Date(y, m, d, h, M, s, ms);

        //the date constructor doesn't accept years < 1970
        if (y < 1970) {
            date.setFullYear(y);
        }
        return date;
    }

    function makeUTCDate(y) {
        var date = new Date(Date.UTC.apply(null, arguments));
        if (y < 1970) {
            date.setUTCFullYear(y);
        }
        return date;
    }

    function parseWeekday(input, locale) {
        if (typeof input === 'string') {
            if (!isNaN(input)) {
                input = parseInt(input, 10);
            } else {
                input = locale.weekdaysParse(input);
                if (typeof input !== 'number') {
                    return null;
                }
            }
        }
        return input;
    }

    /************************************
        Relative Time
    ************************************/


    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime(posNegDuration, withoutSuffix, locale) {
        var duration = moment.duration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            years = round(duration.as('y')),

            args = seconds < relativeTimeThresholds.s && ['s', seconds] ||
                minutes === 1 && ['m'] ||
                minutes < relativeTimeThresholds.m && ['mm', minutes] ||
                hours === 1 && ['h'] ||
                hours < relativeTimeThresholds.h && ['hh', hours] ||
                days === 1 && ['d'] ||
                days < relativeTimeThresholds.d && ['dd', days] ||
                months === 1 && ['M'] ||
                months < relativeTimeThresholds.M && ['MM', months] ||
                years === 1 && ['y'] || ['yy', years];

        args[2] = withoutSuffix;
        args[3] = +posNegDuration > 0;
        args[4] = locale;
        return substituteTimeAgo.apply({}, args);
    }


    /************************************
        Week of Year
    ************************************/


    // firstDayOfWeek       0 = sun, 6 = sat
    //                      the day of the week that starts the week
    //                      (usually sunday or monday)
    // firstDayOfWeekOfYear 0 = sun, 6 = sat
    //                      the first week is the week that contains the first
    //                      of this day of the week
    //                      (eg. ISO weeks use thursday (4))
    function weekOfYear(mom, firstDayOfWeek, firstDayOfWeekOfYear) {
        var end = firstDayOfWeekOfYear - firstDayOfWeek,
            daysToDayOfWeek = firstDayOfWeekOfYear - mom.day(),
            adjustedMoment;


        if (daysToDayOfWeek > end) {
            daysToDayOfWeek -= 7;
        }

        if (daysToDayOfWeek < end - 7) {
            daysToDayOfWeek += 7;
        }

        adjustedMoment = moment(mom).add(daysToDayOfWeek, 'd');
        return {
            week: Math.ceil(adjustedMoment.dayOfYear() / 7),
            year: adjustedMoment.year()
        };
    }

    //http://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, firstDayOfWeekOfYear, firstDayOfWeek) {
        var d = makeUTCDate(year, 0, 1).getUTCDay(), daysToAdd, dayOfYear;

        d = d === 0 ? 7 : d;
        weekday = weekday != null ? weekday : firstDayOfWeek;
        daysToAdd = firstDayOfWeek - d + (d > firstDayOfWeekOfYear ? 7 : 0) - (d < firstDayOfWeek ? 7 : 0);
        dayOfYear = 7 * (week - 1) + (weekday - firstDayOfWeek) + daysToAdd + 1;

        return {
            year: dayOfYear > 0 ? year : year - 1,
            dayOfYear: dayOfYear > 0 ? dayOfYear : daysInYear(year - 1) + dayOfYear
        };
    }

    /************************************
        Top Level Functions
    ************************************/

    function makeMoment(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || moment.localeData(config._l);

        if (input === null || (format === undefined && input === '')) {
            return moment.invalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (moment.isMoment(input)) {
            return new Moment(input, true);
        } else if (format) {
            if (isArray(format)) {
                makeDateFromStringAndArray(config);
            } else {
                makeDateFromStringAndFormat(config);
            }
        } else {
            makeDateFromInput(config);
        }

        return new Moment(config);
    }

    moment = function(input, format, locale, strict) {
        var c;

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._i = input;
        c._f = format;
        c._l = locale;
        c._strict = strict;
        c._isUTC = false;
        c._pf = defaultParsingFlags();

        return makeMoment(c);
    };

    moment.suppressDeprecationWarnings = false;

    moment.createFromInputFallback = deprecate(
        'moment construction falls back to js Date. This is ' +
        'discouraged and will be removed in upcoming major ' +
        'release. Please refer to ' +
        'https://github.com/moment/moment/issues/1407 for more info.',
        function(config) {
            config._d = new Date(config._i);
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return moment();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    moment.min = function() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    };

    moment.max = function() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    };

    // creating with utc
    moment.utc = function(input, format, locale, strict) {
        var c;

        if (typeof(locale) === 'boolean') {
            strict = locale;
            locale = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c = {};
        c._isAMomentObject = true;
        c._useUTC = true;
        c._isUTC = true;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        c._pf = defaultParsingFlags();

        return makeMoment(c).utc();
    };

    // creating with unix timestamp (in seconds)
    moment.unix = function(input) {
        return moment(input * 1000);
    };

    // duration
    moment.duration = function(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            parseIso,
            diffRes;

        if (moment.isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
        } else if (typeof input === 'number') {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetTimeSpanJsonRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(match[MILLISECOND]) * sign
            };
        } else if (!!(match = isoDurationRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            parseIso = function(inp) {
                // We'd normally use ~~inp for this, but unfortunately it also
                // converts floats to ints.
                // inp may be undefined, so careful calling replace on it.
                var res = inp && parseFloat(inp.replace(',', '.'));
                // apply sign while we're at it
                return (isNaN(res) ? 0 : res) * sign;
            };
            duration = {
                y: parseIso(match[2]),
                M: parseIso(match[3]),
                d: parseIso(match[4]),
                h: parseIso(match[5]),
                m: parseIso(match[6]),
                s: parseIso(match[7]),
                w: parseIso(match[8])
            };
        } else if (typeof duration === 'object' &&
        ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(moment(duration.from), moment(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (moment.isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    };

    // version number
    moment.version = VERSION;

    // default format
    moment.defaultFormat = isoFormat;

    // constant that refers to the ISO standard
    moment.ISO_8601 = function() {};

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    moment.momentProperties = momentProperties;

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    moment.updateOffset = function() {};

    // This function allows you to set a threshold for relative time strings
    moment.relativeTimeThreshold = function(threshold, limit) {
        if (relativeTimeThresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return relativeTimeThresholds[threshold];
        }
        relativeTimeThresholds[threshold] = limit;
        return true;
    };

    moment.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        function(key, value) {
            return moment.locale(key, value);
        }
    );

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    moment.locale = function(key, values) {
        var data;
        if (key) {
            if (typeof(values) !== 'undefined') {
                data = moment.defineLocale(key, values);
            } else {
                data = moment.localeData(key);
            }

            if (data) {
                moment.duration._locale = moment._locale = data;
            }
        }

        return moment._locale._abbr;
    };

    moment.defineLocale = function(name, values) {
        if (values !== null) {
            values.abbr = name;
            if (!locales[name]) {
                locales[name] = new Locale();
            }
            locales[name].set(values);

            // backwards compat for now: also set the locale
            moment.locale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    };

    moment.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        function(key) {
            return moment.localeData(key);
        }
    );

    // returns locale data
    moment.localeData = function(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return moment._locale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    };

    // compare moment object
    moment.isMoment = function(obj) {
        return obj instanceof Moment ||
        (obj != null && hasOwnProp(obj, '_isAMomentObject'));
    };

    // for typechecking Duration objects
    moment.isDuration = function(obj) {
        return obj instanceof Duration;
    };

    for (i = lists.length - 1; i >= 0; --i) {
        makeList(lists[i]);
    }

    moment.normalizeUnits = function(units) {
        return normalizeUnits(units);
    };

    moment.invalid = function(flags) {
        var m = moment.utc(NaN);
        if (flags != null) {
            extend(m._pf, flags);
        } else {
            m._pf.userInvalidated = true;
        }

        return m;
    };

    moment.parseZone = function() {
        return moment.apply(null, arguments).parseZone();
    };

    moment.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    /************************************
        Moment Prototype
    ************************************/


    extend(moment.fn = Moment.prototype, {
        clone: function() {
            return moment(this);
        },

        valueOf: function() {
            return +this._d + ((this._offset || 0) * 60000);
        },

        unix: function() {
            return Math.floor(+this / 1000);
        },

        toString: function() {
            return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
        },

        toDate: function() {
            return this._offset ? new Date(+this) : this._d;
        },

        toISOString: function() {
            var m = moment(this).utc();
            if (0 < m.year() && m.year() <= 9999) {
                return formatMoment(m, 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            } else {
                return formatMoment(m, 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]');
            }
        },

        toArray: function() {
            var m = this;
            return [
                m.year(),
                m.month(),
                m.date(),
                m.hours(),
                m.minutes(),
                m.seconds(),
                m.milliseconds()
            ];
        },

        isValid: function() {
            return isValid(this);
        },

        isDSTShifted: function() {
            if (this._a) {
                return this.isValid() && compareArrays(this._a, (this._isUTC ? moment.utc(this._a) : moment(this._a)).toArray()) > 0;
            }

            return false;
        },

        parsingFlags: function() {
            return extend({}, this._pf);
        },

        invalidAt: function() {
            return this._pf.overflow;
        },

        utc: function(keepLocalTime) {
            return this.zone(0, keepLocalTime);
        },

        local: function(keepLocalTime) {
            if (this._isUTC) {
                this.zone(0, keepLocalTime);
                this._isUTC = false;

                if (keepLocalTime) {
                    this.add(this._dateTzOffset(), 'm');
                }
            }
            return this;
        },

        format: function(inputString) {
            var output = formatMoment(this, inputString || moment.defaultFormat);
            return this.localeData().postformat(output);
        },

        add: createAdder(1, 'add'),

        subtract: createAdder(-1, 'subtract'),

        diff: function(input, units, asFloat) {
            var that = makeAs(input, this),
                zoneDiff = (this.zone() - that.zone()) * 6e4,
                diff,
                output,
                daysAdjust;

            units = normalizeUnits(units);

            if (units === 'year' || units === 'month') {
                // average number of days in the months in the given dates
                diff = (this.daysInMonth() + that.daysInMonth()) * 432e5; // 24 * 60 * 60 * 1000 / 2
                // difference in months
                output = ((this.year() - that.year()) * 12) + (this.month() - that.month());
                // adjust by taking difference in days, average number of days
                // and dst in the given months.
                daysAdjust = (this - moment(this).startOf('month')) -
                (that - moment(that).startOf('month'));
                // same as above but with zones, to negate all dst
                daysAdjust -= ((this.zone() - moment(this).startOf('month').zone()) -
                (that.zone() - moment(that).startOf('month').zone())) * 6e4;
                output += daysAdjust / diff;
                if (units === 'year') {
                    output = output / 12;
                }
            } else {
                diff = (this - that);
                output = units === 'second' ? diff / 1e3 : // 1000
                    units === 'minute' ? diff / 6e4 : // 1000 * 60
                    units === 'hour' ? diff / 36e5 : // 1000 * 60 * 60
                    units === 'day' ? (diff - zoneDiff) / 864e5 : // 1000 * 60 * 60 * 24, negate dst
                    units === 'week' ? (diff - zoneDiff) / 6048e5 : // 1000 * 60 * 60 * 24 * 7, negate dst
                    diff;
            }
            return asFloat ? output : absRound(output);
        },

        from: function(time, withoutSuffix) {
            return moment.duration({ to: this, from: time }).locale(this.locale()).humanize(!withoutSuffix);
        },

        fromNow: function(withoutSuffix) {
            return this.from(moment(), withoutSuffix);
        },

        calendar: function(time) {
            // We want to compare the start of today, vs this.
            // Getting start-of-today depends on whether we're zone'd or not.
            var now = time || moment(),
                sod = makeAs(now, this).startOf('day'),
                diff = this.diff(sod, 'days', true),
                format = diff < -6 ? 'sameElse' :
                    diff < -1 ? 'lastWeek' :
                    diff < 0 ? 'lastDay' :
                    diff < 1 ? 'sameDay' :
                    diff < 2 ? 'nextDay' :
                    diff < 7 ? 'nextWeek' : 'sameElse';
            return this.format(this.localeData().calendar(format, this));
        },

        isLeapYear: function() {
            return isLeapYear(this.year());
        },

        isDST: function() {
            return (this.zone() < this.clone().month(0).zone() ||
                this.zone() < this.clone().month(5).zone());
        },

        day: function(input) {
            var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
            if (input != null) {
                input = parseWeekday(input, this.localeData());
                return this.add(input - day, 'd');
            } else {
                return day;
            }
        },

        month: makeAccessor('Month', true),

        startOf: function(units) {
            units = normalizeUnits(units);
            // the following switch intentionally omits break keywords
            // to utilize falling through the cases.
            switch (units) {
            case 'year':
                this.month(0);
            /* falls through */
            case 'quarter':
            case 'month':
                this.date(1);
            /* falls through */
            case 'week':
            case 'isoWeek':
            case 'day':
                this.hours(0);
            /* falls through */
            case 'hour':
                this.minutes(0);
            /* falls through */
            case 'minute':
                this.seconds(0);
            /* falls through */
            case 'second':
                this.milliseconds(0);
                /* falls through */
            }

            // weeks are a special case
            if (units === 'week') {
                this.weekday(0);
            } else if (units === 'isoWeek') {
                this.isoWeekday(1);
            }

            // quarters are also special
            if (units === 'quarter') {
                this.month(Math.floor(this.month() / 3) * 3);
            }

            return this;
        },

        endOf: function(units) {
            units = normalizeUnits(units);
            return this.startOf(units).add(1, (units === 'isoWeek' ? 'week' : units)).subtract(1, 'ms');
        },

        isAfter: function(input, units) {
            units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
            if (units === 'millisecond') {
                input = moment.isMoment(input) ? input : moment(input);
                return +this > +input;
            } else {
                return +this.clone().startOf(units) > +moment(input).startOf(units);
            }
        },

        isBefore: function(input, units) {
            units = normalizeUnits(typeof units !== 'undefined' ? units : 'millisecond');
            if (units === 'millisecond') {
                input = moment.isMoment(input) ? input : moment(input);
                return +this < +input;
            } else {
                return +this.clone().startOf(units) < +moment(input).startOf(units);
            }
        },

        isSame: function(input, units) {
            units = normalizeUnits(units || 'millisecond');
            if (units === 'millisecond') {
                input = moment.isMoment(input) ? input : moment(input);
                return +this === +input;
            } else {
                return +this.clone().startOf(units) === +makeAs(input, this).startOf(units);
            }
        },

        min: deprecate(
            'moment().min is deprecated, use moment.min instead. https://github.com/moment/moment/issues/1548',
            function(other) {
                other = moment.apply(null, arguments);
                return other < this ? this : other;
            }
        ),

        max: deprecate(
            'moment().max is deprecated, use moment.max instead. https://github.com/moment/moment/issues/1548',
            function(other) {
                other = moment.apply(null, arguments);
                return other > this ? this : other;
            }
        ),

        // keepLocalTime = true means only change the timezone, without
        // affecting the local hour. So 5:31:26 +0300 --[zone(2, true)]-->
        // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist int zone
        // +0200, so we adjust the time as needed, to be valid.
        //
        // Keeping the time actually adds/subtracts (one hour)
        // from the actual represented time. That is why we call updateOffset
        // a second time. In case it wants us to change the offset again
        // _changeInProgress == true case, then we have to adjust, because
        // there is no such time in the given timezone.
        zone: function(input, keepLocalTime) {
            var offset = this._offset || 0,
                localAdjust;
            if (input != null) {
                if (typeof input === 'string') {
                    input = timezoneMinutesFromString(input);
                }
                if (Math.abs(input) < 16) {
                    input = input * 60;
                }
                if (!this._isUTC && keepLocalTime) {
                    localAdjust = this._dateTzOffset();
                }
                this._offset = input;
                this._isUTC = true;
                if (localAdjust != null) {
                    this.subtract(localAdjust, 'm');
                }
                if (offset !== input) {
                    if (!keepLocalTime || this._changeInProgress) {
                        addOrSubtractDurationFromMoment(this,
                            moment.duration(offset - input, 'm'), 1, false);
                    } else if (!this._changeInProgress) {
                        this._changeInProgress = true;
                        moment.updateOffset(this, true);
                        this._changeInProgress = null;
                    }
                }
            } else {
                return this._isUTC ? offset : this._dateTzOffset();
            }
            return this;
        },

        zoneAbbr: function() {
            return this._isUTC ? 'UTC' : '';
        },

        zoneName: function() {
            return this._isUTC ? 'Coordinated Universal Time' : '';
        },

        parseZone: function() {
            if (this._tzm) {
                this.zone(this._tzm);
            } else if (typeof this._i === 'string') {
                this.zone(this._i);
            }
            return this;
        },

        hasAlignedHourOffset: function(input) {
            if (!input) {
                input = 0;
            } else {
                input = moment(input).zone();
            }

            return (this.zone() - input) % 60 === 0;
        },

        daysInMonth: function() {
            return daysInMonth(this.year(), this.month());
        },

        dayOfYear: function(input) {
            var dayOfYear = round((moment(this).startOf('day') - moment(this).startOf('year')) / 864e5) + 1;
            return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
        },

        quarter: function(input) {
            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
        },

        weekYear: function(input) {
            var year = weekOfYear(this, this.localeData()._week.dow, this.localeData()._week.doy).year;
            return input == null ? year : this.add((input - year), 'y');
        },

        isoWeekYear: function(input) {
            var year = weekOfYear(this, 1, 4).year;
            return input == null ? year : this.add((input - year), 'y');
        },

        week: function(input) {
            var week = this.localeData().week(this);
            return input == null ? week : this.add((input - week) * 7, 'd');
        },

        isoWeek: function(input) {
            var week = weekOfYear(this, 1, 4).week;
            return input == null ? week : this.add((input - week) * 7, 'd');
        },

        weekday: function(input) {
            var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return input == null ? weekday : this.add(input - weekday, 'd');
        },

        isoWeekday: function(input) {
            // behaves the same as moment#day except
            // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
            // as a setter, sunday should belong to the previous week.
            return input == null ? this.day() || 7 : this.day(this.day() % 7 ? input : input - 7);
        },

        isoWeeksInYear: function() {
            return weeksInYear(this.year(), 1, 4);
        },

        weeksInYear: function() {
            var weekInfo = this.localeData()._week;
            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
        },

        get: function(units) {
            units = normalizeUnits(units);
            return this[units]();
        },

        set: function(units, value) {
            units = normalizeUnits(units);
            if (typeof this[units] === 'function') {
                this[units](value);
            }
            return this;
        },

        // If passed a locale key, it will set the locale for this
        // instance.  Otherwise, it will return the locale configuration
        // variables for this instance.
        locale: function(key) {
            var newLocaleData;

            if (key === undefined) {
                return this._locale._abbr;
            } else {
                newLocaleData = moment.localeData(key);
                if (newLocaleData != null) {
                    this._locale = newLocaleData;
                }
                return this;
            }
        },

        lang: deprecate(
            'moment().lang() is deprecated. Use moment().localeData() instead.',
            function(key) {
                if (key === undefined) {
                    return this.localeData();
                } else {
                    return this.locale(key);
                }
            }
        ),

        localeData: function() {
            return this._locale;
        },

        _dateTzOffset: function() {
            // On Firefox.24 Date#getTimezoneOffset returns a floating point.
            // https://github.com/moment/moment/pull/1871
            return Math.round(this._d.getTimezoneOffset() / 15) * 15;
        }
    });

    function rawMonthSetter(mom, value) {
        var dayOfMonth;

        // TODO: Move this out of here!
        if (typeof value === 'string') {
            value = mom.localeData().monthsParse(value);
            // TODO: Another silent failure?
            if (typeof value !== 'number') {
                return mom;
            }
        }

        dayOfMonth = Math.min(mom.date(),
            daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function rawGetter(mom, unit) {
        return mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]();
    }

    function rawSetter(mom, unit, value) {
        if (unit === 'Month') {
            return rawMonthSetter(mom, value);
        } else {
            return mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
        }
    }

    function makeAccessor(unit, keepTime) {
        return function(value) {
            if (value != null) {
                rawSetter(this, unit, value);
                moment.updateOffset(this, keepTime);
                return this;
            } else {
                return rawGetter(this, unit);
            }
        };
    }

    moment.fn.millisecond = moment.fn.milliseconds = makeAccessor('Milliseconds', false);
    moment.fn.second = moment.fn.seconds = makeAccessor('Seconds', false);
    moment.fn.minute = moment.fn.minutes = makeAccessor('Minutes', false);
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour he wants. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    moment.fn.hour = moment.fn.hours = makeAccessor('Hours', true);
    // moment.fn.month is defined separately
    moment.fn.date = makeAccessor('Date', true);
    moment.fn.dates = deprecate('dates accessor is deprecated. Use date instead.', makeAccessor('Date', true));
    moment.fn.year = makeAccessor('FullYear', true);
    moment.fn.years = deprecate('years accessor is deprecated. Use year instead.', makeAccessor('FullYear', true));

    // add plural methods
    moment.fn.days = moment.fn.day;
    moment.fn.months = moment.fn.month;
    moment.fn.weeks = moment.fn.week;
    moment.fn.isoWeeks = moment.fn.isoWeek;
    moment.fn.quarters = moment.fn.quarter;

    // add aliased format methods
    moment.fn.toJSON = moment.fn.toISOString;

    /************************************
        Duration Prototype
    ************************************/


    function daysToYears(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        return days * 400 / 146097;
    }

    function yearsToDays(years) {
        // years * 365 + absRound(years / 4) -
        //     absRound(years / 100) + absRound(years / 400);
        return years * 146097 / 400;
    }

    extend(moment.duration.fn = Duration.prototype, {
        _bubble: function() {
            var milliseconds = this._milliseconds,
                days = this._days,
                months = this._months,
                data = this._data,
                seconds,
                minutes,
                hours,
                years = 0;

            // The following code bubbles up values, see the tests for
            // examples of what that means.
            data.milliseconds = milliseconds % 1000;

            seconds = absRound(milliseconds / 1000);
            data.seconds = seconds % 60;

            minutes = absRound(seconds / 60);
            data.minutes = minutes % 60;

            hours = absRound(minutes / 60);
            data.hours = hours % 24;

            days += absRound(hours / 24);

            // Accurately convert days to years, assume start from year 0.
            years = absRound(daysToYears(days));
            days -= absRound(yearsToDays(years));

            // 30 days to a month
            // TODO (iskren): Use anchor date (like 1st Jan) to compute this.
            months += absRound(days / 30);
            days %= 30;

            // 12 months -> 1 year
            years += absRound(months / 12);
            months %= 12;

            data.days = days;
            data.months = months;
            data.years = years;
        },

        abs: function() {
            this._milliseconds = Math.abs(this._milliseconds);
            this._days = Math.abs(this._days);
            this._months = Math.abs(this._months);

            this._data.milliseconds = Math.abs(this._data.milliseconds);
            this._data.seconds = Math.abs(this._data.seconds);
            this._data.minutes = Math.abs(this._data.minutes);
            this._data.hours = Math.abs(this._data.hours);
            this._data.months = Math.abs(this._data.months);
            this._data.years = Math.abs(this._data.years);

            return this;
        },

        weeks: function() {
            return absRound(this.days() / 7);
        },

        valueOf: function() {
            return this._milliseconds +
                this._days * 864e5 +
                (this._months % 12) * 2592e6 +
                toInt(this._months / 12) * 31536e6;
        },

        humanize: function(withSuffix) {
            var output = relativeTime(this, !withSuffix, this.localeData());

            if (withSuffix) {
                output = this.localeData().pastFuture(+this, output);
            }

            return this.localeData().postformat(output);
        },

        add: function(input, val) {
            // supports only 2.0-style add(1, 's') or add(moment)
            var dur = moment.duration(input, val);

            this._milliseconds += dur._milliseconds;
            this._days += dur._days;
            this._months += dur._months;

            this._bubble();

            return this;
        },

        subtract: function(input, val) {
            var dur = moment.duration(input, val);

            this._milliseconds -= dur._milliseconds;
            this._days -= dur._days;
            this._months -= dur._months;

            this._bubble();

            return this;
        },

        get: function(units) {
            units = normalizeUnits(units);
            return this[units.toLowerCase() + 's']();
        },

        as: function(units) {
            var days, months;
            units = normalizeUnits(units);

            if (units === 'month' || units === 'year') {
                days = this._days + this._milliseconds / 864e5;
                months = this._months + daysToYears(days) * 12;
                return units === 'month' ? months : months / 12;
            } else {
                // handle milliseconds separately because of floating point math errors (issue #1867)
                days = this._days + yearsToDays(this._months / 12);
                switch (units) {
                case 'week':
                    return days / 7 + this._milliseconds / 6048e5;
                case 'day':
                    return days + this._milliseconds / 864e5;
                case 'hour':
                    return days * 24 + this._milliseconds / 36e5;
                case 'minute':
                    return days * 24 * 60 + this._milliseconds / 6e4;
                case 'second':
                    return days * 24 * 60 * 60 + this._milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 24 * 60 * 60 * 1000) + this._milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
                }
            }
        },

        lang: moment.fn.lang,
        locale: moment.fn.locale,

        toIsoString: deprecate(
            'toIsoString() is deprecated. Please use toISOString() instead ' +
            '(notice the capitals)',
            function() {
                return this.toISOString();
            }
        ),

        toISOString: function() {
            // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
            var years = Math.abs(this.years()),
                months = Math.abs(this.months()),
                days = Math.abs(this.days()),
                hours = Math.abs(this.hours()),
                minutes = Math.abs(this.minutes()),
                seconds = Math.abs(this.seconds() + this.milliseconds() / 1000);

            if (!this.asSeconds()) {
                // this is the same as C#'s (Noda) and python (isodate)...
                // but not other JS (goog.date)
                return 'P0D';
            }

            return (this.asSeconds() < 0 ? '-' : '') +
                'P' +
                (years ? years + 'Y' : '') +
                (months ? months + 'M' : '') +
                (days ? days + 'D' : '') +
                ((hours || minutes || seconds) ? 'T' : '') +
                (hours ? hours + 'H' : '') +
                (minutes ? minutes + 'M' : '') +
                (seconds ? seconds + 'S' : '');
        },

        localeData: function() {
            return this._locale;
        }
    });

    moment.duration.fn.toString = moment.duration.fn.toISOString;

    function makeDurationGetter(name) {
        moment.duration.fn[name] = function() {
            return this._data[name];
        };
    }

    for (i in unitMillisecondFactors) {
        if (hasOwnProp(unitMillisecondFactors, i)) {
            makeDurationGetter(i.toLowerCase());
        }
    }

    moment.duration.fn.asMilliseconds = function() {
        return this.as('ms');
    };
    moment.duration.fn.asSeconds = function() {
        return this.as('s');
    };
    moment.duration.fn.asMinutes = function() {
        return this.as('m');
    };
    moment.duration.fn.asHours = function() {
        return this.as('h');
    };
    moment.duration.fn.asDays = function() {
        return this.as('d');
    };
    moment.duration.fn.asWeeks = function() {
        return this.as('weeks');
    };
    moment.duration.fn.asMonths = function() {
        return this.as('M');
    };
    moment.duration.fn.asYears = function() {
        return this.as('y');
    };

    /************************************
        Default Locale
    ************************************/


    // Set default locale, other locale will inherit from English.
    moment.locale('en', {
        ordinal: function(number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    /* EMBED_LOCALES */

    /************************************
        Exposing Moment
    ************************************/

    function makeGlobal(shouldDeprecate) {
        /*global ender:false */
        if (typeof ender !== 'undefined') {
            return;
        }
        oldGlobalMoment = globalScope.moment;
        if (shouldDeprecate) {
            globalScope.moment = deprecate(
                'Accessing Moment through the global scope is ' +
                'deprecated, and will be removed in an upcoming ' +
                'release.',
                moment);
        } else {
            globalScope.moment = moment;
        }
    }

    // CommonJS module is defined
    if (hasModule) {
        module.exports = moment;
    } else if (typeof define === 'function' && define.amd) {
        define('moment', function(require, exports, module) {
            if (module.config && module.config() && module.config().noGlobal === true) {
                // release the global variable
                globalScope.moment = oldGlobalMoment;
            }

            return moment;
        });
        makeGlobal(true);
    } else {
        makeGlobal();
    }
}).call(this);
// controls the tooltip
class TooltipController {

  constructor(id) {
    this._tipID = 0;
    riot.observable(this);
  }

  /**
   * Singleton
   */
  static get instance() {
    if (!window.tooltipController) {
      window.tooltipController = new TooltipController();
    }
    return window.tooltipController;
  }

  registerTooltip() {
    this._tipID += 1;
    return this._tipID;
  }

  showTooltip(id) {
    this.trigger('activeTooltipChanged', id);
  }

  closeAllTooltips() {
    this.trigger('activeTooltipChanged', null);
  }

}
const utils = {};

utils.isNullOrUndefined = (arg) => {
  return arg === null || arg === undefined || arg === '' || arg ==='null';
};

utils.isEmpty = (obj) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      return false;
    }
  }
  return true;
};

/* utils.scrollTo = (element, to, duration) => {
  if (duration <= 0) {
    return;
  }
  const difference = to - element.scrollTop;
  const perTick = difference / duration * 10;

  setTimeout(() => {
    element.scrollTop = element.scrollTop + perTick;
    if (element.scrollTop === to) {
      return;
    }
    scrollTo(element, to, duration - 10);
  }, 10);
};*/

utils.getInitials = (firstName, lastName) => {
  return firstName.charAt(0) + lastName.charAt(0);
};

utils.debounceTimer = 0;
utils.isDebouncing = false;

utils.debounce = (timeToWait, functionToExecute) => {
  utils.debounceTimer = timeToWait;
  let start = null;

  function step(timestamp) {
    if (!start) {
      start = timestamp;
    }
    const progress = timestamp - start;
    if (progress < timeToWait) {
      window.requestAnimationFrame(step);
    } else {
      utils.isDebouncing = false;
      functionToExecute();
    }
  }

  if(!utils.isDebouncing) {
    window.requestAnimationFrame(step);
    utils.isDebouncing = true;
  }
};

// Credit David Walsh (https://davidwalsh.name/javascript-debounce-function)

// Returns a function, that, as long as it continues to be invoked, will not
// be triggered. The function will be called after it stops being called for
// N milliseconds. If `immediate` is passed, trigger the function on the
// leading edge, instead of the trailing.
utils.debounceFunction = (func, wait, immediate) => {
  let timeout;

  return function executedFunction() {
    const context = this;
    const args = arguments;

    const later = function() {
      timeout = null;
      if (!immediate) {
        func.apply(context, args);
      }
    };

    const callNow = immediate && !timeout;

    window.clearTimeout(timeout);

    timeout = window.setTimeout(later, wait);

    if (callNow) {
      func.apply(context, args);
    }
  };
};

utils.dec2hex = (dec) => {
  return (`0${dec.toString(16)}`.substr(-2));
};

/**
 * Generates a random integer.
 * The minimum number is inclusive and the max number is exclusive.
 * @param minInclusive
 * @param maxExclusive
 * @returns {*}
 */
utils.getRandomInt = (minInclusive, maxExclusive) => {
  minInclusive = Math.ceil(minInclusive);
  maxExclusive = Math.floor(maxExclusive);
  return Math.floor(Math.random() * (maxExclusive - minInclusive)) + minInclusive;
};

/**
 * Generates a simple, alphabet-characters-only id.
 * @param len
 * @returns {string}
 */
utils.generateId = (len) => {
  const arr = [];
  for (let i = 0; i < len; ++i) {
    const n = utils.getRandomInt(10, 26);
    const s = n.toString(36);
    arr.push(s);
  }
  return arr.join('');
};

utils.GetComposedPath = (element) => {
  if (element === null) {
    return [];
  }

  const pathArr = [element];

  while (element.parentElement !== null) {
    element = element.parentElement;
    pathArr.unshift(element);
  }

  return pathArr;
};

/*!
 * jquery-timepicker v1.4.7 - A jQuery timepicker plugin inspired by Google Calendar. It supports both mouse and keyboard navigation.
 * Copyright (c) 2014 Jon Thornton - http://jonthornton.github.com/jquery-timepicker/
 * License: 
 */

!function(a) { "function" == typeof define && define.amd ? define(["jquery"], a) : a(jQuery) }(function(a) {
    function b(a) {
        if (a.minTime && (a.minTime = t(a.minTime)), a.maxTime && (a.maxTime = t(a.maxTime)), a.durationTime && "function" != typeof a.durationTime && (a.durationTime = t(a.durationTime)), "now" == a.scrollDefault ? a.scrollDefault = t(new Date) : a.scrollDefault ? a.scrollDefault = t(a.scrollDefault) : a.minTime && (a.scrollDefault = a.minTime), a.scrollDefault && (a.scrollDefault = e(a.scrollDefault, a)), a.timeFormat.match(/[gh]/) && (a._twelveHourTime = !0), a.disableTimeRanges.length > 0) {
            for (var b in a.disableTimeRanges)a.disableTimeRanges[b] = [t(a.disableTimeRanges[b][0]), t(a.disableTimeRanges[b][1])];
            a.disableTimeRanges = a.disableTimeRanges.sort(function(a, b) { return a[0] - b[0] });
            for (var b = a.disableTimeRanges.length - 1; b > 0; b--)a.disableTimeRanges[b][0] <= a.disableTimeRanges[b - 1][1] && (a.disableTimeRanges[b - 1] = [Math.min(a.disableTimeRanges[b][0], a.disableTimeRanges[b - 1][0]), Math.max(a.disableTimeRanges[b][1], a.disableTimeRanges[b - 1][1])], a.disableTimeRanges.splice(b, 1))
        }
        return a
    }

    function c(b) {
        var c = b.data("timepicker-settings"), e = b.data("timepicker-list");
        if (e && e.length && (e.remove(), b.data("timepicker-list", !1)), c.useSelect) {
            e = a("<select />", { "class": "ui-timepicker-select" });
            var g = e
        } else {
            e = a("<ul />", { "class": "ui-timepicker-list" });
            var g = a("<div />", { "class": "ui-timepicker-wrapper", tabindex: -1 });
            g.css({ display: "none", position: "absolute" }).append(e)
        }
        if (c.noneOption)
            if (c.noneOption === !0 && (c.noneOption = c.useSelect ? "Time..." : "None"), a.isArray(c.noneOption)) {
                for (var h in c.noneOption)
                    if (parseInt(h, 10) == h) {
                        var j = d(c.noneOption[h], c.useSelect);
                        e.append(j)
                    }
            } else {
                var j = d(c.noneOption, c.useSelect);
                e.append(j)
            }
        c.className && g.addClass(c.className), null === c.minTime && null === c.durationTime || !c.showDuration || (g.addClass("ui-timepicker-with-duration"), g.addClass("ui-timepicker-step-" + c.step));
        var l = c.minTime;
        "function" == typeof c.durationTime ? l = t(c.durationTime()) : null !== c.durationTime && (l = c.durationTime);
        var m = null !== c.minTime ? c.minTime : 0, o = null !== c.maxTime ? c.maxTime : m + v - 1;
        m >= o && (o += v), o === v - 1 && -1 !== c.timeFormat.indexOf("H") && (o = v);
        for (var p = c.disableTimeRanges, u = 0, w = p.length, h = m; o >= h; h += 60 * c.step) {
            var y = h, z = s(y, c.timeFormat);
            if (c.useSelect) {
                var A = a("<option />", { value: z });
                A.text(z)
            } else {
                var A = a("<li />");
                A.data("time", 86400 >= y ? y : y % 86400), A.text(z)
            }
            if ((null !== c.minTime || null !== c.durationTime) && c.showDuration) {
                var B = r(h - l, c.step);
                if (c.useSelect)A.text(A.text() + " (" + B + ")");
                else {
                    var C = a("<span />", { "class": "ui-timepicker-duration" });
                    C.text(" (" + B + ")"), A.append(C)
                }
            }
            w > u && (y >= p[u][1] && (u += 1), p[u] && y >= p[u][0] && y < p[u][1] && (c.useSelect ? A.prop("disabled", !0) : A.addClass("ui-timepicker-disabled"))), e.append(A)
        }
        if (g.data("timepicker-input", b), b.data("timepicker-list", g), c.useSelect)e.val(f(b.val(), c)), e.on("focus", function() { a(this).data("timepicker-input").trigger("showTimepicker") }), e.on("blur", function() { a(this).data("timepicker-input").trigger("hideTimepicker") }), e.on("change", function() { n(b, a(this).val(), "select") }), b.hide().after(e);
        else {
            var D = c.appendTo;
            "string" == typeof D ? D = a(D) : "function" == typeof D && (D = D(b)), D.append(g), k(b, e), e.on("mousedown", "li", function() { b.off("focus.timepicker"), b.on("focus.timepicker-ie-hack", function() { b.off("focus.timepicker-ie-hack"), b.on("focus.timepicker", x.show) }), i(b) || b[0].focus(), e.find("li").removeClass("ui-timepicker-selected"), a(this).addClass("ui-timepicker-selected"), q(b) && (b.trigger("hideTimepicker"), g.hide()) })
        }
    }

    function d(b, c) {
        var d, e, f;
        return"object" == typeof b ? (d = b.label, e = b.className, f = b.value) : "string" == typeof b ? d = b : a.error("Invalid noneOption value"), c ? a("<option />", { value: f, "class": e, text: d }) : a("<li />", { "class": e, text: d }).data("time", f)
    }

    function e(b, c) {
        if (a.isNumeric(b) || (b = t(b)), null === b)return null;
        var d = b % (60 * c.step);
        return d >= 30 * c.step ? b += 60 * c.step - d : b -= d, b
    }

    function f(a, b) { return a = e(a, b), null !== a ? s(a, b.timeFormat) : void 0 }

    function g() { return new Date(1970, 1, 1, 0, 0, 0) }

    function h(b) {
        var c = a(b.target), d = c.closest(".ui-timepicker-input");
        0 === d.length && 0 === c.closest(".ui-timepicker-wrapper").length && (x.hide(), a(document).unbind(".ui-timepicker"))
    }

    function i(a) {
        var b = a.data("timepicker-settings");
        return(window.navigator.msMaxTouchPoints || "ontouchstart" in document) && b.disableTouchKeyboard
    }

    function j(b, c, d) {
        if (!d && 0 !== d)return!1;
        var e = b.data("timepicker-settings"), f = !1, g = 30 * e.step;
        return c.find("li").each(function(b, c) {
            var e = a(c);
            if ("number" == typeof e.data("time")) {
                var h = e.data("time") - d;
                return Math.abs(h) < g || h == g ? (f = e, !1) : void 0
            }
        }), f
    }

    function k(a, b) {
        b.find("li").removeClass("ui-timepicker-selected");
        var c = t(m(a), a.data("timepicker-settings"));
        if (null !== c) {
            var d = j(a, b, c);
            if (d) {
                var e = d.offset().top - b.offset().top;
                (e + d.outerHeight() > b.outerHeight() || 0 > e) && b.scrollTop(b.scrollTop() + d.position().top - d.outerHeight()), d.addClass("ui-timepicker-selected")
            }
        }
    }

    function l(b) {
        if ("" !== this.value) {
            var c = a(this);
            if (c.data("timepicker-list"), !c.is(":focus") || b && "change" == b.type) {
                var d = t(this.value);
                if (null === d)return c.trigger("timeFormatError"), void 0;
                var e = c.data("timepicker-settings"), f = !1;
                if (null !== e.minTime && d < e.minTime ? f = !0 : null !== e.maxTime && d > e.maxTime && (f = !0), a.each(e.disableTimeRanges, function() { return d >= this[0] && d < this[1] ? (f = !0, !1) : void 0 }), e.forceRoundTime) {
                    var g = d % (60 * e.step);
                    g >= 30 * e.step ? d += 60 * e.step - g : d -= g
                }
                var h = s(d, e.timeFormat);
                f ? n(c, h, "error") && c.trigger("timeRangeError") : n(c, h)
            }
        }
    }

    function m(a) { return a.is("input") ? a.val() : a.data("ui-timepicker-value") }

    function n(a, b, c) {
        if (a.is("input")) {
            a.val(b);
            var d = a.data("timepicker-settings");
            d.useSelect && a.data("timepicker-list").val(f(b, d))
        }
        return a.data("ui-timepicker-value") != b ? (a.data("ui-timepicker-value", b), "select" == c ? a.trigger("selectTime").trigger("changeTime").trigger("change") : "error" != c && a.trigger("changeTime"), !0) : (a.trigger("selectTime"), !1)
    }

    function o(b) {
        var c = a(this), d = c.data("timepicker-list");
        if (!d || !d.is(":visible")) {
            if (40 != b.keyCode)return!0;
            x.show.call(c.get(0)), d = c.data("timepicker-list"), i(c) || c.focus()
        }
        switch (b.keyCode) {
        case 13:
            return q(c) && x.hide.apply(this), b.preventDefault(), !1;
        case 38:
            var e = d.find(".ui-timepicker-selected");
            return e.length ? e.is(":first-child") || (e.removeClass("ui-timepicker-selected"), e.prev().addClass("ui-timepicker-selected"), e.prev().position().top < e.outerHeight() && d.scrollTop(d.scrollTop() - e.outerHeight())) : (d.find("li").each(function(b, c) { return a(c).position().top > 0 ? (e = a(c), !1) : void 0 }), e.addClass("ui-timepicker-selected")), !1;
        case 40:
            return e = d.find(".ui-timepicker-selected"), 0 === e.length ? (d.find("li").each(function(b, c) { return a(c).position().top > 0 ? (e = a(c), !1) : void 0 }), e.addClass("ui-timepicker-selected")) : e.is(":last-child") || (e.removeClass("ui-timepicker-selected"), e.next().addClass("ui-timepicker-selected"), e.next().position().top + 2 * e.outerHeight() > d.outerHeight() && d.scrollTop(d.scrollTop() + e.outerHeight())), !1;
        case 27:
            d.find("li").removeClass("ui-timepicker-selected"), x.hide();
            break;
        case 9:
            x.hide();
            break;
        default:
            return!0
        }
    }

    function p(b) {
        var c = a(this), d = c.data("timepicker-list");
        if (!d || !d.is(":visible"))return!0;
        if (!c.data("timepicker-settings").typeaheadHighlight)return d.find("li").removeClass("ui-timepicker-selected"), !0;
        switch (b.keyCode) {
        case 96:
        case 97:
        case 98:
        case 99:
        case 100:
        case 101:
        case 102:
        case 103:
        case 104:
        case 105:
        case 48:
        case 49:
        case 50:
        case 51:
        case 52:
        case 53:
        case 54:
        case 55:
        case 56:
        case 57:
        case 65:
        case 77:
        case 80:
        case 186:
        case 8:
        case 46:
            k(c, d);
            break;
        default:
            return
        }
    }

    function q(a) {
        var b = a.data("timepicker-settings"), c = a.data("timepicker-list"), d = null, e = c.find(".ui-timepicker-selected");
        if (e.hasClass("ui-timepicker-disabled"))return!1;
        if (e.length && (d = e.data("time")), null !== d)
            if ("string" == typeof d)a.val(d);
            else {
                var f = s(d, b.timeFormat);
                n(a, f, "select")
            }
        return!0
    }

    function r(a, b) {
        a = Math.abs(a);
        var c, d, e = Math.round(a / 60), f = [];
        return 60 > e ? f = [e, w.mins] : (c = Math.floor(e / 60), d = e % 60, 30 == b && 30 == d && (c += w.decimal + 5), f.push(c), f.push(1 == c ? w.hr : w.hrs), 30 != b && d && (f.push(d), f.push(w.mins))), f.join(" ")
    }

    function s(a, b) {
        if (null !== a) {
            var c = new Date(u.valueOf() + 1e3 * a);
            if (!isNaN(c.getTime())) {
                for (var d, e, f = "", g = 0; g < b.length; g++)
                    switch (e = b.charAt(g)) {
                    case"a":
                        f += c.getHours() > 11 ? w.pm : w.am;
                        break;
                    case"A":
                        f += c.getHours() > 11 ? w.PM : w.AM;
                        break;
                    case"g":
                        d = c.getHours() % 12, f += 0 === d ? "12" : d;
                        break;
                    case"G":
                        f += c.getHours();
                        break;
                    case"h":
                        d = c.getHours() % 12, 0 !== d && 10 > d && (d = "0" + d), f += 0 === d ? "12" : d;
                        break;
                    case"H":
                        d = c.getHours(), a === v && (d = 24), f += d > 9 ? d : "0" + d;
                        break;
                    case"i":
                        var h = c.getMinutes();
                        f += h > 9 ? h : "0" + h;
                        break;
                    case"s":
                        a = c.getSeconds(), f += a > 9 ? a : "0" + a;
                        break;
                    case"\\":
                        g++, f += b.charAt(g);
                        break;
                    default:
                        f += e
                    }
                return f
            }
        }
    }

    function t(a, b) {
        if ("" === a)return null;
        if (!a || a + 0 == a)return a;
        if ("object" == typeof a)return 3600 * a.getHours() + 60 * a.getMinutes() + a.getSeconds();
        a = a.toLowerCase(), new Date(0);
        var c;
        if (c = a.match(/^([0-2]?[0-9])\W?([0-5][0-9])?\W?([0-5][0-9])?\s*([pa]?)m?$/), !c)return null;
        var d = parseInt(1 * c[1], 10), e = c[4], f = d;
        e && (f = 12 == d ? "p" == c[4] ? 12 : 0 : d + ("p" == c[4] ? 12 : 0));
        var g = 1 * c[2] || 0, h = 1 * c[3] || 0, i = 3600 * f + 60 * g + h;
        if (!e && b && b._twelveHourTime && b.scrollDefault) {
            var j = i - b.scrollDefault;
            0 > j && j >= v / -2 && (i = (i + v / 2) % v)
        }
        return i
    }

    var u = g(), v = 86400, w = { am: "am", pm: "pm", AM: "AM", PM: "PM", decimal: ".", mins: "mins", hr: "hr", hrs: "hrs" },
        x = {
            init: function(d) {
                return this.each(function() {
                    var e = a(this), f = [];
                    for (var g in a.fn.timepicker.defaults)e.data(g) && (f[g] = e.data(g));
                    var h = a.extend({}, a.fn.timepicker.defaults, f, d);
                    h.lang && (w = a.extend(w, h.lang)), h = b(h), e.data("timepicker-settings", h), e.addClass("ui-timepicker-input"), h.useSelect ? c(e) : (e.prop("autocomplete", "off"), e.on("click.timepicker focus.timepicker", x.show), e.on("change.timepicker", l), e.on("keydown.timepicker", o), e.on("keyup.timepicker", p), l.call(e.get(0)))
                })
            },
            show: function(b) {
                var d = a(this), e = d.data("timepicker-settings");
                if (b) {
                    if (!e.showOnFocus)return!0;
                    b.preventDefault()
                }
                if (e.useSelect)return d.data("timepicker-list").focus(), void 0;
                i(d) && d.blur();
                var f = d.data("timepicker-list");
                if (!d.prop("readonly") && (f && 0 !== f.length && "function" != typeof e.durationTime || (c(d), f = d.data("timepicker-list")), !f.is(":visible"))) {
                    x.hide(), f.show();
                    var g = {};
                    g.left = "rtl" == e.orientation ? d.offset().left + d.outerWidth() - f.outerWidth() + parseInt(f.css("marginLeft").replace("px", ""), 10) : d.offset().left + parseInt(f.css("marginLeft").replace("px", ""), 10), g.top = d.offset().top + d.outerHeight(!0) + f.outerHeight() > a(window).height() + a(window).scrollTop() ? d.offset().top - f.outerHeight() + parseInt(f.css("marginTop").replace("px", ""), 10) : d.offset().top + d.outerHeight() + parseInt(f.css("marginTop").replace("px", ""), 10), f.offset(g);
                    var k = f.find(".ui-timepicker-selected");
                    if (k.length || (m(d) ? k = j(d, f, t(m(d))) : e.scrollDefault && (k = j(d, f, e.scrollDefault))), k && k.length) {
                        var l = f.scrollTop() + k.position().top - k.outerHeight();
                        f.scrollTop(l)
                    } else f.scrollTop(0);
                    return a(document).on("touchstart.ui-timepicker mousedown.ui-timepicker", h), e.closeOnWindowScroll && a(document).on("scroll.ui-timepicker", h), d.trigger("showTimepicker"), this
                }
            },
            hide: function() {
                var b = a(this), c = b.data("timepicker-settings");
                return c && c.useSelect && b.blur(), a(".ui-timepicker-wrapper:visible").each(function() {
                    var b = a(this), c = b.data("timepicker-input"), d = c.data("timepicker-settings");
                    d && d.selectOnBlur && q(c), b.hide(), c.trigger("hideTimepicker")
                }), this
            },
            option: function(d, e) {
                return this.each(function() {
                    var f = a(this), g = f.data("timepicker-settings"), h = f.data("timepicker-list");
                    if ("object" == typeof d)g = a.extend(g, d);
                    else if ("string" == typeof d && "undefined" != typeof e)g[d] = e;
                    else if ("string" == typeof d)return g[d];
                    g = b(g), f.data("timepicker-settings", g), h && (h.remove(), f.data("timepicker-list", !1)), g.useSelect && c(f)
                })
            },
            getSecondsFromMidnight: function() { return t(m(this)) },
            getTime: function(a) {
                var b = this, c = m(b);
                if (!c)return null;
                a || (a = new Date);
                var d = t(c), e = new Date(a);
                return e.setHours(d / 3600), e.setMinutes(d % 3600 / 60), e.setSeconds(d % 60), e.setMilliseconds(0), e
            },
            setTime: function(a) {
                var b = this, c = b.data("timepicker-settings");
                if (c.forceRoundTime)var d = f(a, c);
                else var d = s(t(a), c.timeFormat);
                return n(b, d), b.data("timepicker-list") && k(b, b.data("timepicker-list")), this
            },
            remove: function() {
                var a = this;
                if (a.hasClass("ui-timepicker-input")) {
                    var b = a.data("timepicker-settings");
                    return a.removeAttr("autocomplete", "off"), a.removeClass("ui-timepicker-input"), a.removeData("timepicker-settings"), a.off(".timepicker"), a.data("timepicker-list") && a.data("timepicker-list").remove(), b.useSelect && a.show(), a.removeData("timepicker-list"), this
                }
            }
        };
    a.fn.timepicker = function(b) { return this.length ? x[b] ? this.hasClass("ui-timepicker-input") ? x[b].apply(this, Array.prototype.slice.call(arguments, 1)) : this : "object" != typeof b && b ? (a.error("Method " + b + " does not exist on jQuery.timepicker"), void 0) : x.init.apply(this, arguments) : this }, a.fn.timepicker.defaults = { className: null, minTime: null, maxTime: null, durationTime: null, step: 30, showDuration: !1, showOnFocus: !0, timeFormat: "g:ia", scrollDefault: null, selectOnBlur: !1, disableTouchKeyboard: !1, forceRoundTime: !1, appendTo: "body", orientation: "ltr", disableTimeRanges: [], closeOnWindowScroll: !1, typeaheadHighlight: !0, noneOption: !1 }
});
/*! http://mths.be/placeholder v2.0.7 by @mathias */
;
(function(window, document, $) {

    var isInputSupported = 'placeholder' in document.createElement('input');
    var isTextareaSupported = 'placeholder' in document.createElement('textarea');
    var prototype = $.fn;
    var valHooks = $.valHooks;
    var propHooks = $.propHooks;
    var hooks;
    var placeholder;

    if (isInputSupported && isTextareaSupported) {

        placeholder = prototype.placeholder = function() {
            return this;
        };

        placeholder.input = placeholder.textarea = true;

    } else {

        placeholder = prototype.placeholder = function() {
            var $this = this;
            $this
                .filter((isInputSupported ? 'textarea' : ':input') + '[placeholder]')
                .not('.placeholder')
                .bind({
                    'focus.placeholder': clearPlaceholder,
                    'blur.placeholder': setPlaceholder
                })
                .data('placeholder-enabled', true)
                .trigger('blur.placeholder');
            return $this;
        };

        placeholder.input = isInputSupported;
        placeholder.textarea = isTextareaSupported;

        hooks = {
            'get': function(element) {
                var $element = $(element);

                var $passwordInput = $element.data('placeholder-password');
                if ($passwordInput) {
                    return $passwordInput[0].value;
                }

                return $element.data('placeholder-enabled') && $element.hasClass('placeholder') ? '' : element.value;
            },
            'set': function(element, value) {
                var $element = $(element);

                var $passwordInput = $element.data('placeholder-password');
                if ($passwordInput) {
                    return $passwordInput[0].value = value;
                }

                if (!$element.data('placeholder-enabled')) {
                    return element.value = value;
                }
                if (value == '') {
                    element.value = value;
                    // Issue #56: Setting the placeholder causes problems if the element continues to have focus.
                    if (element != safeActiveElement()) {
                        // We can't use `triggerHandler` here because of dummy text/password inputs :(
                        setPlaceholder.call(element);
                    }
                } else if ($element.hasClass('placeholder')) {
                    clearPlaceholder.call(element, true, value) || (element.value = value);
                } else {
                    element.value = value;
                }
                // `set` can not return `undefined`; see http://jsapi.info/jquery/1.7.1/val#L2363
                return $element;
            }
        };

        if (!isInputSupported) {
            valHooks.input = hooks;
            propHooks.value = hooks;
        }
        if (!isTextareaSupported) {
            valHooks.textarea = hooks;
            propHooks.value = hooks;
        }

        $(function() {
            // Look for forms
            $(document).delegate('form', 'submit.placeholder', function() {
                // Clear the placeholder values so they don't get submitted
                var $inputs = $('.placeholder', this).each(clearPlaceholder);
                setTimeout(function() {
                    $inputs.each(setPlaceholder);
                }, 10);
            });
        });

        // Clear placeholder values upon page reload
        $(window).bind('beforeunload.placeholder', function() {
            $('.placeholder').each(function() {
                this.value = '';
            });
        });

    }

    function args(elem) {
        // Return an object of element attributes
        var newAttrs = {};
        var rinlinejQuery = /^jQuery\d+$/;
        $.each(elem.attributes, function(i, attr) {
            if (attr.specified && !rinlinejQuery.test(attr.name)) {
                newAttrs[attr.name] = attr.value;
            }
        });
        return newAttrs;
    }

    function clearPlaceholder(event, value) {
        var input = this;
        var $input = $(input);
        if (input.value == $input.attr('placeholder') && $input.hasClass('placeholder')) {
            if ($input.data('placeholder-password')) {
                $input = $input.hide().next().show().attr('id', $input.removeAttr('id').data('placeholder-id'));
                // If `clearPlaceholder` was called from `$.valHooks.input.set`
                if (event === true) {
                    return $input[0].value = value;
                }
                $input.focus();
            } else {
                input.value = '';
                $input.removeClass('placeholder');
                input == safeActiveElement() && input.select();
            }
        }
    }

    function setPlaceholder() {
        var $replacement;
        var input = this;
        var $input = $(input);
        var id = this.id;
        if (input.value == '') {
            if (input.type == 'password') {
                if (!$input.data('placeholder-textinput')) {
                    try {
                        $replacement = $input.clone().attr({ 'type': 'text' });
                    } catch (e) {
                        $replacement = $('<input>').attr($.extend(args(this), { 'type': 'text' }));
                    }
                    $replacement
                        .removeAttr('name')
                        .data({
                            'placeholder-password': $input,
                            'placeholder-id': id
                        })
                        .bind('focus.placeholder', clearPlaceholder);
                    $input
                        .data({
                            'placeholder-textinput': $replacement,
                            'placeholder-id': id
                        })
                        .before($replacement);
                }
                $input = $input.removeAttr('id').hide().prev().attr('id', id).show();
                // Note: `$input[0] != input` now!
            }
            $input.addClass('placeholder');
            $input[0].value = $input.attr('placeholder');
        } else {
            $input.removeClass('placeholder');
        }
    }

    function safeActiveElement() {
        // Avoid IE9 `document.activeElement` of death
        // https://github.com/mathiasbynens/jquery-placeholder/pull/99
        try {
            return document.activeElement;
        } catch (err) {
        }
    }

}(this, document, jQuery));
$.scrollLock = (function scrollLockClosure() {
    'use strict';

    var $html = $('html'),
        // State: unlocked by default
        locked = false,
        // State: scroll to revert to
        prevScroll = {
            scrollLeft: $(window).scrollLeft(),
            scrollTop: $(window).scrollTop()
        },
        // State: styles to revert to
        prevStyles = {},
        lockStyles = {
            'overflow-y': 'scroll',
            'position': 'fixed',
            'width': '100%'
        };

    // Instantiate cache in case someone tries to unlock before locking
    saveStyles();

    // Save context's inline styles in cache
    function saveStyles() {
        var styleAttr = $html.attr('style'),
            styleStrs = [],
            styleHash = {};

        if (!styleAttr) {
            return;
        }

        styleStrs = styleAttr.split(/;\s/);

        $.each(styleStrs, function serializeStyleProp(styleString) {
            if (!styleString) {
                return;
            }

            var keyValue = styleString.split(/\s:\s/);

            if (keyValue.length < 2) {
                return;
            }

            styleHash[keyValue[0]] = keyValue[1];
        });

        $.extend(prevStyles, styleHash);
    }

    function lock() {
        var appliedLock = {};

        // Duplicate execution will break DOM statefulness
        if (locked) {
            return;
        }

        // Save scroll state...
        prevScroll = {
            scrollLeft: $(window).scrollLeft(),
            scrollTop: $(window).scrollTop()
        };

        // ...and styles
        saveStyles();

        // Compose our applied CSS
        $.extend(appliedLock, lockStyles, {
            // And apply scroll state as styles
            'left': - prevScroll.scrollLeft + 'px',
            'top': - prevScroll.scrollTop + 'px'
        });

        // Then lock styles...
        $html.css(appliedLock);

        // ...and scroll state
        $(window)
            .scrollLeft(0)
            .scrollTop(0);

        locked = true;
    }

    function unlock() {
        // Duplicate execution will break DOM statefulness
        if (!locked) {
            return;
        }

        // Revert styles
        $html.attr('style', $('<x>').css(prevStyles).attr('style') || '');

        // Revert scroll values
        $(window)
            .scrollLeft(prevScroll.scrollLeft)
            .scrollTop(prevScroll.scrollTop);

        locked = false;
    }

    return function scrollLock(on) {
        // If an argument is passed, lock or unlock depending on truthiness
        if (arguments.length) {
            if (on) {
                lock();
            } else {
                unlock();
            }
        }
        // Otherwise, toggle
        else {
            if (locked) {
                unlock();
            } else {
                lock();
            }
        }
    };
}());
/*!
 * jQuery.ScrollTo
 * Copyright (c) 2007-2012 Ariel Flesler - aflesler(at)gmail(dot)com | http://flesler.blogspot.com
 * Dual licensed under MIT and GPL.
 * Date: 4/09/2012
 *
 * @projectDescription Easy element scrolling using jQuery.
 * http://flesler.blogspot.com/2007/10/jqueryscrollto.html
 * @author Ariel Flesler
 * @version 1.4.3.1
 *
 * @id jQuery.scrollTo
 * @id jQuery.fn.scrollTo
 * @param {String, Number, DOMElement, jQuery, Object} target Where to scroll the matched elements.
 *	  The different options for target are:
 *		- A number position (will be applied to all axes).
 *		- A string position ('44', '100px', '+=90', etc ) will be applied to all axes
 *		- A jQuery/DOM element ( logically, child of the element to scroll )
 *		- A string selector, that will be relative to the element to scroll ( 'li:eq(2)', etc )
 *		- A hash { top:x, left:y }, x and y can be any kind of number/string like above.
 *		- A percentage of the container's dimension/s, for example: 50% to go to the middle.
 *		- The string 'max' for go-to-end. 
 * @param {Number, Function} duration The OVERALL length of the animation, this argument can be the settings object instead.
 * @param {Object,Function} settings Optional set of settings or the onAfter callback.
 *	 @option {String} axis Which axis must be scrolled, use 'x', 'y', 'xy' or 'yx'.
 *	 @option {Number, Function} duration The OVERALL length of the animation.
 *	 @option {String} easing The easing method for the animation.
 *	 @option {Boolean} margin If true, the margin of the target element will be deducted from the final position.
 *	 @option {Object, Number} offset Add/deduct from the end position. One number for both axes or { top:x, left:y }.
 *	 @option {Object, Number} over Add/deduct the height/width multiplied by 'over', can be { top:x, left:y } when using both axes.
 *	 @option {Boolean} queue If true, and both axis are given, the 2nd axis will only be animated after the first one ends.
 *	 @option {Function} onAfter Function to be called after the scrolling ends. 
 *	 @option {Function} onAfterFirst If queuing is activated, this function will be called after the first scrolling ends.
 * @return {jQuery} Returns the same jQuery object, for chaining.
 *
 * @desc Scroll to a fixed position
 * @example $('div').scrollTo( 340 );
 *
 * @desc Scroll relatively to the actual position
 * @example $('div').scrollTo( '+=340px', { axis:'y' } );
 *
 * @desc Scroll using a selector (relative to the scrolled element)
 * @example $('div').scrollTo( 'p.paragraph:eq(2)', 500, { easing:'swing', queue:true, axis:'xy' } );
 *
 * @desc Scroll to a DOM element (same for jQuery object)
 * @example var second_child = document.getElementById('container').firstChild.nextSibling;
 *			$('#container').scrollTo( second_child, { duration:500, axis:'x', onAfter:function(){
 *				alert('scrolled!!');																   
 *			}});
 *
 * @desc Scroll on both axes, to different values
 * @example $('div').scrollTo( { top: 300, left:'+=200' }, { axis:'xy', offset:-20 } );
 */

;
(function($) {

    var $scrollTo = $.scrollTo = function(target, duration, settings) {
        $(window).scrollTo(target, duration, settings);
    };

    $scrollTo.defaults = {
        axis: 'xy',
        duration: parseFloat($.fn.jquery) >= 1.3 ? 0 : 1,
        limit: true
    };

    // Returns the element that needs to be animated to scroll the window.
    // Kept for backwards compatibility (specially for localScroll & serialScroll)
    $scrollTo.window = function(scope) {
        return $(window)._scrollable();
    };

    // Hack, hack, hack :)
    // Returns the real elements to scroll (supports window/iframes, documents and regular nodes)
    $.fn._scrollable = function() {
        return this.map(function() {
            var elem = this,
                isWin = !elem.nodeName || $.inArray(elem.nodeName.toLowerCase(), ['iframe', '#document', 'html', 'body']) != -1;

            if (!isWin)
                return elem;

            var doc = (elem.contentWindow || elem).document || elem.ownerDocument || elem;

            return /webkit/i.test(navigator.userAgent) || doc.compatMode == 'BackCompat' ?
                doc.body :
                doc.documentElement;
        });
    };

    $.fn.scrollTo = function(target, duration, settings) {
        if (typeof duration == 'object') {
            settings = duration;
            duration = 0;
        }
        if (typeof settings == 'function')
            settings = { onAfter: settings };

        if (target == 'max')
            target = 9e9;

        settings = $.extend({}, $scrollTo.defaults, settings);
        // Speed is still recognized for backwards compatibility
        duration = duration || settings.duration;
        // Make sure the settings are given right
        settings.queue = settings.queue && settings.axis.length > 1;

        if (settings.queue)
        // Let's keep the overall duration
            duration /= 2;
        settings.offset = both(settings.offset);
        settings.over = both(settings.over);

        return this._scrollable().each(function() {
            // Null target yields nothing, just like jQuery does
            if (target == null) return;

            var elem = this,
                $elem = $(elem),
                targ = target,
                toff,
                attr = {},
                win = $elem.is('html, body');

            switch (typeof targ) {
                // A number will pass the regex
            case 'number':
            case 'string':
                if (/^([+-]=)?\d+(\.\d+)?(px|%)?$/.test(targ)) {
                    targ = both(targ);
                    // We are done
                    break;
                }
                // Relative selector, no break!
                targ = $(targ, this);
                if (!targ.length) return;
            case 'object':
                // DOMElement / jQuery
                if (targ.is || targ.style)
                // Get the real position of the target 
                    toff = (targ = $(targ)).offset();
            }
            $.each(settings.axis.split(''), function(i, axis) {
                var Pos = axis == 'x' ? 'Left' : 'Top',
                    pos = Pos.toLowerCase(),
                    key = 'scroll' + Pos,
                    old = elem[key],
                    max = $scrollTo.max(elem, axis);

                if (toff) { // jQuery / DOMElement
                    attr[key] = toff[pos] + (win ? 0 : old - $elem.offset()[pos]);

                    // If it's a dom element, reduce the margin
                    if (settings.margin) {
                        attr[key] -= parseInt(targ.css('margin' + Pos)) || 0;
                        attr[key] -= parseInt(targ.css('border' + Pos + 'Width')) || 0;
                    }

                    attr[key] += settings.offset[pos] || 0;

                    if (settings.over[pos])
                    // Scroll to a fraction of its width/height
                        attr[key] += targ[axis == 'x' ? 'width' : 'height']() * settings.over[pos];
                } else {
                    var val = targ[pos];
                    // Handle percentage values
                    attr[key] = val.slice && val.slice(-1) == '%' ?
                        parseFloat(val) / 100 * max
                        : val;
                }

                // Number or 'number'
                if (settings.limit && /^\d+$/.test(attr[key]))
                // Check the limits
                    attr[key] = attr[key] <= 0 ? 0 : Math.min(attr[key], max);

                // Queueing axes
                if (!i && settings.queue) {
                    // Don't waste time animating, if there's no need.
                    if (old != attr[key])
                    // Intermediate animation
                        animate(settings.onAfterFirst);
                    // Don't animate this axis again in the next iteration.
                    delete attr[key];
                }
            });

            animate(settings.onAfter);

            function animate(callback) {
                $elem.animate(attr, duration, settings.easing, callback && function() {
                    callback.call(this, target, settings);
                });
            };

        }).end();
    };

    // Max scrolling position, works on quirks mode
    // It only fails (not too badly) on IE, quirks mode.
    $scrollTo.max = function(elem, axis) {
        var Dim = axis == 'x' ? 'Width' : 'Height',
            scroll = 'scroll' + Dim;

        if (!$(elem).is('html, body'))
            return elem[scroll] - $(elem)[Dim.toLowerCase()]();

        var size = 'client' + Dim,
            html = elem.ownerDocument.documentElement,
            body = elem.ownerDocument.body;

        return Math.max(html[scroll], body[scroll])
            - Math.min(html[size], body[size]);
    };

    function both(val) {
        return typeof val == 'object' ? val : { top: val, left: val };
    };

})(jQuery);
//     Underscore.js 1.9.1
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.
!function(){var n="object"==typeof self&&self.self===self&&self||"object"==typeof global&&global.global===global&&global||this||{},r=n._,e=Array.prototype,o=Object.prototype,s="undefined"!=typeof Symbol?Symbol.prototype:null,u=e.push,c=e.slice,p=o.toString,i=o.hasOwnProperty,t=Array.isArray,a=Object.keys,l=Object.create,f=function(){},h=function(n){return n instanceof h?n:this instanceof h?void(this._wrapped=n):new h(n)};"undefined"==typeof exports||exports.nodeType?n._=h:("undefined"!=typeof module&&!module.nodeType&&module.exports&&(exports=module.exports=h),exports._=h),h.VERSION="1.9.1";var v,y=function(u,i,n){if(void 0===i)return u;switch(null==n?3:n){case 1:return function(n){return u.call(i,n)};case 3:return function(n,r,t){return u.call(i,n,r,t)};case 4:return function(n,r,t,e){return u.call(i,n,r,t,e)}}return function(){return u.apply(i,arguments)}},d=function(n,r,t){return h.iteratee!==v?h.iteratee(n,r):null==n?h.identity:h.isFunction(n)?y(n,r,t):h.isObject(n)&&!h.isArray(n)?h.matcher(n):h.property(n)};h.iteratee=v=function(n,r){return d(n,r,1/0)};var g=function(u,i){return i=null==i?u.length-1:+i,function(){for(var n=Math.max(arguments.length-i,0),r=Array(n),t=0;t<n;t++)r[t]=arguments[t+i];switch(i){case 0:return u.call(this,r);case 1:return u.call(this,arguments[0],r);case 2:return u.call(this,arguments[0],arguments[1],r)}var e=Array(i+1);for(t=0;t<i;t++)e[t]=arguments[t];return e[i]=r,u.apply(this,e)}},m=function(n){if(!h.isObject(n))return{};if(l)return l(n);f.prototype=n;var r=new f;return f.prototype=null,r},b=function(r){return function(n){return null==n?void 0:n[r]}},j=function(n,r){return null!=n&&i.call(n,r)},x=function(n,r){for(var t=r.length,e=0;e<t;e++){if(null==n)return;n=n[r[e]]}return t?n:void 0},_=Math.pow(2,53)-1,A=b("length"),w=function(n){var r=A(n);return"number"==typeof r&&0<=r&&r<=_};h.each=h.forEach=function(n,r,t){var e,u;if(r=y(r,t),w(n))for(e=0,u=n.length;e<u;e++)r(n[e],e,n);else{var i=h.keys(n);for(e=0,u=i.length;e<u;e++)r(n[i[e]],i[e],n)}return n},h.map=h.collect=function(n,r,t){r=d(r,t);for(var e=!w(n)&&h.keys(n),u=(e||n).length,i=Array(u),o=0;o<u;o++){var a=e?e[o]:o;i[o]=r(n[a],a,n)}return i};var O=function(c){return function(n,r,t,e){var u=3<=arguments.length;return function(n,r,t,e){var u=!w(n)&&h.keys(n),i=(u||n).length,o=0<c?0:i-1;for(e||(t=n[u?u[o]:o],o+=c);0<=o&&o<i;o+=c){var a=u?u[o]:o;t=r(t,n[a],a,n)}return t}(n,y(r,e,4),t,u)}};h.reduce=h.foldl=h.inject=O(1),h.reduceRight=h.foldr=O(-1),h.find=h.detect=function(n,r,t){var e=(w(n)?h.findIndex:h.findKey)(n,r,t);if(void 0!==e&&-1!==e)return n[e]},h.filter=h.select=function(n,e,r){var u=[];return e=d(e,r),h.each(n,function(n,r,t){e(n,r,t)&&u.push(n)}),u},h.reject=function(n,r,t){return h.filter(n,h.negate(d(r)),t)},h.every=h.all=function(n,r,t){r=d(r,t);for(var e=!w(n)&&h.keys(n),u=(e||n).length,i=0;i<u;i++){var o=e?e[i]:i;if(!r(n[o],o,n))return!1}return!0},h.some=h.any=function(n,r,t){r=d(r,t);for(var e=!w(n)&&h.keys(n),u=(e||n).length,i=0;i<u;i++){var o=e?e[i]:i;if(r(n[o],o,n))return!0}return!1},h.contains=h.includes=h.include=function(n,r,t,e){return w(n)||(n=h.values(n)),("number"!=typeof t||e)&&(t=0),0<=h.indexOf(n,r,t)},h.invoke=g(function(n,t,e){var u,i;return h.isFunction(t)?i=t:h.isArray(t)&&(u=t.slice(0,-1),t=t[t.length-1]),h.map(n,function(n){var r=i;if(!r){if(u&&u.length&&(n=x(n,u)),null==n)return;r=n[t]}return null==r?r:r.apply(n,e)})}),h.pluck=function(n,r){return h.map(n,h.property(r))},h.where=function(n,r){return h.filter(n,h.matcher(r))},h.findWhere=function(n,r){return h.find(n,h.matcher(r))},h.max=function(n,e,r){var t,u,i=-1/0,o=-1/0;if(null==e||"number"==typeof e&&"object"!=typeof n[0]&&null!=n)for(var a=0,c=(n=w(n)?n:h.values(n)).length;a<c;a++)null!=(t=n[a])&&i<t&&(i=t);else e=d(e,r),h.each(n,function(n,r,t){u=e(n,r,t),(o<u||u===-1/0&&i===-1/0)&&(i=n,o=u)});return i},h.min=function(n,e,r){var t,u,i=1/0,o=1/0;if(null==e||"number"==typeof e&&"object"!=typeof n[0]&&null!=n)for(var a=0,c=(n=w(n)?n:h.values(n)).length;a<c;a++)null!=(t=n[a])&&t<i&&(i=t);else e=d(e,r),h.each(n,function(n,r,t){((u=e(n,r,t))<o||u===1/0&&i===1/0)&&(i=n,o=u)});return i},h.shuffle=function(n){return h.sample(n,1/0)},h.sample=function(n,r,t){if(null==r||t)return w(n)||(n=h.values(n)),n[h.random(n.length-1)];var e=w(n)?h.clone(n):h.values(n),u=A(e);r=Math.max(Math.min(r,u),0);for(var i=u-1,o=0;o<r;o++){var a=h.random(o,i),c=e[o];e[o]=e[a],e[a]=c}return e.slice(0,r)},h.sortBy=function(n,e,r){var u=0;return e=d(e,r),h.pluck(h.map(n,function(n,r,t){return{value:n,index:u++,criteria:e(n,r,t)}}).sort(function(n,r){var t=n.criteria,e=r.criteria;if(t!==e){if(e<t||void 0===t)return 1;if(t<e||void 0===e)return-1}return n.index-r.index}),"value")};var k=function(o,r){return function(e,u,n){var i=r?[[],[]]:{};return u=d(u,n),h.each(e,function(n,r){var t=u(n,r,e);o(i,n,t)}),i}};h.groupBy=k(function(n,r,t){j(n,t)?n[t].push(r):n[t]=[r]}),h.indexBy=k(function(n,r,t){n[t]=r}),h.countBy=k(function(n,r,t){j(n,t)?n[t]++:n[t]=1});var S=/[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;h.toArray=function(n){return n?h.isArray(n)?c.call(n):h.isString(n)?n.match(S):w(n)?h.map(n,h.identity):h.values(n):[]},h.size=function(n){return null==n?0:w(n)?n.length:h.keys(n).length},h.partition=k(function(n,r,t){n[t?0:1].push(r)},!0),h.first=h.head=h.take=function(n,r,t){return null==n||n.length<1?null==r?void 0:[]:null==r||t?n[0]:h.initial(n,n.length-r)},h.initial=function(n,r,t){return c.call(n,0,Math.max(0,n.length-(null==r||t?1:r)))},h.last=function(n,r,t){return null==n||n.length<1?null==r?void 0:[]:null==r||t?n[n.length-1]:h.rest(n,Math.max(0,n.length-r))},h.rest=h.tail=h.drop=function(n,r,t){return c.call(n,null==r||t?1:r)},h.compact=function(n){return h.filter(n,Boolean)};var M=function(n,r,t,e){for(var u=(e=e||[]).length,i=0,o=A(n);i<o;i++){var a=n[i];if(w(a)&&(h.isArray(a)||h.isArguments(a)))if(r)for(var c=0,l=a.length;c<l;)e[u++]=a[c++];else M(a,r,t,e),u=e.length;else t||(e[u++]=a)}return e};h.flatten=function(n,r){return M(n,r,!1)},h.without=g(function(n,r){return h.difference(n,r)}),h.uniq=h.unique=function(n,r,t,e){h.isBoolean(r)||(e=t,t=r,r=!1),null!=t&&(t=d(t,e));for(var u=[],i=[],o=0,a=A(n);o<a;o++){var c=n[o],l=t?t(c,o,n):c;r&&!t?(o&&i===l||u.push(c),i=l):t?h.contains(i,l)||(i.push(l),u.push(c)):h.contains(u,c)||u.push(c)}return u},h.union=g(function(n){return h.uniq(M(n,!0,!0))}),h.intersection=function(n){for(var r=[],t=arguments.length,e=0,u=A(n);e<u;e++){var i=n[e];if(!h.contains(r,i)){var o;for(o=1;o<t&&h.contains(arguments[o],i);o++);o===t&&r.push(i)}}return r},h.difference=g(function(n,r){return r=M(r,!0,!0),h.filter(n,function(n){return!h.contains(r,n)})}),h.unzip=function(n){for(var r=n&&h.max(n,A).length||0,t=Array(r),e=0;e<r;e++)t[e]=h.pluck(n,e);return t},h.zip=g(h.unzip),h.object=function(n,r){for(var t={},e=0,u=A(n);e<u;e++)r?t[n[e]]=r[e]:t[n[e][0]]=n[e][1];return t};var F=function(i){return function(n,r,t){r=d(r,t);for(var e=A(n),u=0<i?0:e-1;0<=u&&u<e;u+=i)if(r(n[u],u,n))return u;return-1}};h.findIndex=F(1),h.findLastIndex=F(-1),h.sortedIndex=function(n,r,t,e){for(var u=(t=d(t,e,1))(r),i=0,o=A(n);i<o;){var a=Math.floor((i+o)/2);t(n[a])<u?i=a+1:o=a}return i};var E=function(i,o,a){return function(n,r,t){var e=0,u=A(n);if("number"==typeof t)0<i?e=0<=t?t:Math.max(t+u,e):u=0<=t?Math.min(t+1,u):t+u+1;else if(a&&t&&u)return n[t=a(n,r)]===r?t:-1;if(r!=r)return 0<=(t=o(c.call(n,e,u),h.isNaN))?t+e:-1;for(t=0<i?e:u-1;0<=t&&t<u;t+=i)if(n[t]===r)return t;return-1}};h.indexOf=E(1,h.findIndex,h.sortedIndex),h.lastIndexOf=E(-1,h.findLastIndex),h.range=function(n,r,t){null==r&&(r=n||0,n=0),t||(t=r<n?-1:1);for(var e=Math.max(Math.ceil((r-n)/t),0),u=Array(e),i=0;i<e;i++,n+=t)u[i]=n;return u},h.chunk=function(n,r){if(null==r||r<1)return[];for(var t=[],e=0,u=n.length;e<u;)t.push(c.call(n,e,e+=r));return t};var N=function(n,r,t,e,u){if(!(e instanceof r))return n.apply(t,u);var i=m(n.prototype),o=n.apply(i,u);return h.isObject(o)?o:i};h.bind=g(function(r,t,e){if(!h.isFunction(r))throw new TypeError("Bind must be called on a function");var u=g(function(n){return N(r,u,t,this,e.concat(n))});return u}),h.partial=g(function(u,i){var o=h.partial.placeholder,a=function(){for(var n=0,r=i.length,t=Array(r),e=0;e<r;e++)t[e]=i[e]===o?arguments[n++]:i[e];for(;n<arguments.length;)t.push(arguments[n++]);return N(u,a,this,this,t)};return a}),(h.partial.placeholder=h).bindAll=g(function(n,r){var t=(r=M(r,!1,!1)).length;if(t<1)throw new Error("bindAll must be passed function names");for(;t--;){var e=r[t];n[e]=h.bind(n[e],n)}}),h.memoize=function(e,u){var i=function(n){var r=i.cache,t=""+(u?u.apply(this,arguments):n);return j(r,t)||(r[t]=e.apply(this,arguments)),r[t]};return i.cache={},i},h.delay=g(function(n,r,t){return setTimeout(function(){return n.apply(null,t)},r)}),h.defer=h.partial(h.delay,h,1),h.throttle=function(t,e,u){var i,o,a,c,l=0;u||(u={});var f=function(){l=!1===u.leading?0:h.now(),i=null,c=t.apply(o,a),i||(o=a=null)},n=function(){var n=h.now();l||!1!==u.leading||(l=n);var r=e-(n-l);return o=this,a=arguments,r<=0||e<r?(i&&(clearTimeout(i),i=null),l=n,c=t.apply(o,a),i||(o=a=null)):i||!1===u.trailing||(i=setTimeout(f,r)),c};return n.cancel=function(){clearTimeout(i),l=0,i=o=a=null},n},h.debounce=function(t,e,u){var i,o,a=function(n,r){i=null,r&&(o=t.apply(n,r))},n=g(function(n){if(i&&clearTimeout(i),u){var r=!i;i=setTimeout(a,e),r&&(o=t.apply(this,n))}else i=h.delay(a,e,this,n);return o});return n.cancel=function(){clearTimeout(i),i=null},n},h.wrap=function(n,r){return h.partial(r,n)},h.negate=function(n){return function(){return!n.apply(this,arguments)}},h.compose=function(){var t=arguments,e=t.length-1;return function(){for(var n=e,r=t[e].apply(this,arguments);n--;)r=t[n].call(this,r);return r}},h.after=function(n,r){return function(){if(--n<1)return r.apply(this,arguments)}},h.before=function(n,r){var t;return function(){return 0<--n&&(t=r.apply(this,arguments)),n<=1&&(r=null),t}},h.once=h.partial(h.before,2),h.restArguments=g;var I=!{toString:null}.propertyIsEnumerable("toString"),T=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],B=function(n,r){var t=T.length,e=n.constructor,u=h.isFunction(e)&&e.prototype||o,i="constructor";for(j(n,i)&&!h.contains(r,i)&&r.push(i);t--;)(i=T[t])in n&&n[i]!==u[i]&&!h.contains(r,i)&&r.push(i)};h.keys=function(n){if(!h.isObject(n))return[];if(a)return a(n);var r=[];for(var t in n)j(n,t)&&r.push(t);return I&&B(n,r),r},h.allKeys=function(n){if(!h.isObject(n))return[];var r=[];for(var t in n)r.push(t);return I&&B(n,r),r},h.values=function(n){for(var r=h.keys(n),t=r.length,e=Array(t),u=0;u<t;u++)e[u]=n[r[u]];return e},h.mapObject=function(n,r,t){r=d(r,t);for(var e=h.keys(n),u=e.length,i={},o=0;o<u;o++){var a=e[o];i[a]=r(n[a],a,n)}return i},h.pairs=function(n){for(var r=h.keys(n),t=r.length,e=Array(t),u=0;u<t;u++)e[u]=[r[u],n[r[u]]];return e},h.invert=function(n){for(var r={},t=h.keys(n),e=0,u=t.length;e<u;e++)r[n[t[e]]]=t[e];return r},h.functions=h.methods=function(n){var r=[];for(var t in n)h.isFunction(n[t])&&r.push(t);return r.sort()};var R=function(c,l){return function(n){var r=arguments.length;if(l&&(n=Object(n)),r<2||null==n)return n;for(var t=1;t<r;t++)for(var e=arguments[t],u=c(e),i=u.length,o=0;o<i;o++){var a=u[o];l&&void 0!==n[a]||(n[a]=e[a])}return n}};h.extend=R(h.allKeys),h.extendOwn=h.assign=R(h.keys),h.findKey=function(n,r,t){r=d(r,t);for(var e,u=h.keys(n),i=0,o=u.length;i<o;i++)if(r(n[e=u[i]],e,n))return e};var q,K,z=function(n,r,t){return r in t};h.pick=g(function(n,r){var t={},e=r[0];if(null==n)return t;h.isFunction(e)?(1<r.length&&(e=y(e,r[1])),r=h.allKeys(n)):(e=z,r=M(r,!1,!1),n=Object(n));for(var u=0,i=r.length;u<i;u++){var o=r[u],a=n[o];e(a,o,n)&&(t[o]=a)}return t}),h.omit=g(function(n,t){var r,e=t[0];return h.isFunction(e)?(e=h.negate(e),1<t.length&&(r=t[1])):(t=h.map(M(t,!1,!1),String),e=function(n,r){return!h.contains(t,r)}),h.pick(n,e,r)}),h.defaults=R(h.allKeys,!0),h.create=function(n,r){var t=m(n);return r&&h.extendOwn(t,r),t},h.clone=function(n){return h.isObject(n)?h.isArray(n)?n.slice():h.extend({},n):n},h.tap=function(n,r){return r(n),n},h.isMatch=function(n,r){var t=h.keys(r),e=t.length;if(null==n)return!e;for(var u=Object(n),i=0;i<e;i++){var o=t[i];if(r[o]!==u[o]||!(o in u))return!1}return!0},q=function(n,r,t,e){if(n===r)return 0!==n||1/n==1/r;if(null==n||null==r)return!1;if(n!=n)return r!=r;var u=typeof n;return("function"===u||"object"===u||"object"==typeof r)&&K(n,r,t,e)},K=function(n,r,t,e){n instanceof h&&(n=n._wrapped),r instanceof h&&(r=r._wrapped);var u=p.call(n);if(u!==p.call(r))return!1;switch(u){case"[object RegExp]":case"[object String]":return""+n==""+r;case"[object Number]":return+n!=+n?+r!=+r:0==+n?1/+n==1/r:+n==+r;case"[object Date]":case"[object Boolean]":return+n==+r;case"[object Symbol]":return s.valueOf.call(n)===s.valueOf.call(r)}var i="[object Array]"===u;if(!i){if("object"!=typeof n||"object"!=typeof r)return!1;var o=n.constructor,a=r.constructor;if(o!==a&&!(h.isFunction(o)&&o instanceof o&&h.isFunction(a)&&a instanceof a)&&"constructor"in n&&"constructor"in r)return!1}e=e||[];for(var c=(t=t||[]).length;c--;)if(t[c]===n)return e[c]===r;if(t.push(n),e.push(r),i){if((c=n.length)!==r.length)return!1;for(;c--;)if(!q(n[c],r[c],t,e))return!1}else{var l,f=h.keys(n);if(c=f.length,h.keys(r).length!==c)return!1;for(;c--;)if(l=f[c],!j(r,l)||!q(n[l],r[l],t,e))return!1}return t.pop(),e.pop(),!0},h.isEqual=function(n,r){return q(n,r)},h.isEmpty=function(n){return null==n||(w(n)&&(h.isArray(n)||h.isString(n)||h.isArguments(n))?0===n.length:0===h.keys(n).length)},h.isElement=function(n){return!(!n||1!==n.nodeType)},h.isArray=t||function(n){return"[object Array]"===p.call(n)},h.isObject=function(n){var r=typeof n;return"function"===r||"object"===r&&!!n},h.each(["Arguments","Function","String","Number","Date","RegExp","Error","Symbol","Map","WeakMap","Set","WeakSet"],function(r){h["is"+r]=function(n){return p.call(n)==="[object "+r+"]"}}),h.isArguments(arguments)||(h.isArguments=function(n){return j(n,"callee")});var D=n.document&&n.document.childNodes;"function"!=typeof/./&&"object"!=typeof Int8Array&&"function"!=typeof D&&(h.isFunction=function(n){return"function"==typeof n||!1}),h.isFinite=function(n){return!h.isSymbol(n)&&isFinite(n)&&!isNaN(parseFloat(n))},h.isNaN=function(n){return h.isNumber(n)&&isNaN(n)},h.isBoolean=function(n){return!0===n||!1===n||"[object Boolean]"===p.call(n)},h.isNull=function(n){return null===n},h.isUndefined=function(n){return void 0===n},h.has=function(n,r){if(!h.isArray(r))return j(n,r);for(var t=r.length,e=0;e<t;e++){var u=r[e];if(null==n||!i.call(n,u))return!1;n=n[u]}return!!t},h.noConflict=function(){return n._=r,this},h.identity=function(n){return n},h.constant=function(n){return function(){return n}},h.noop=function(){},h.property=function(r){return h.isArray(r)?function(n){return x(n,r)}:b(r)},h.propertyOf=function(r){return null==r?function(){}:function(n){return h.isArray(n)?x(r,n):r[n]}},h.matcher=h.matches=function(r){return r=h.extendOwn({},r),function(n){return h.isMatch(n,r)}},h.times=function(n,r,t){var e=Array(Math.max(0,n));r=y(r,t,1);for(var u=0;u<n;u++)e[u]=r(u);return e},h.random=function(n,r){return null==r&&(r=n,n=0),n+Math.floor(Math.random()*(r-n+1))},h.now=Date.now||function(){return(new Date).getTime()};var L={"&":"&amp;","<":"&lt;",">":"&gt;",'"':"&quot;","'":"&#x27;","`":"&#x60;"},P=h.invert(L),W=function(r){var t=function(n){return r[n]},n="(?:"+h.keys(r).join("|")+")",e=RegExp(n),u=RegExp(n,"g");return function(n){return n=null==n?"":""+n,e.test(n)?n.replace(u,t):n}};h.escape=W(L),h.unescape=W(P),h.result=function(n,r,t){h.isArray(r)||(r=[r]);var e=r.length;if(!e)return h.isFunction(t)?t.call(n):t;for(var u=0;u<e;u++){var i=null==n?void 0:n[r[u]];void 0===i&&(i=t,u=e),n=h.isFunction(i)?i.call(n):i}return n};var C=0;h.uniqueId=function(n){var r=++C+"";return n?n+r:r},h.templateSettings={evaluate:/<%([\s\S]+?)%>/g,interpolate:/<%=([\s\S]+?)%>/g,escape:/<%-([\s\S]+?)%>/g};var J=/(.)^/,U={"'":"'","\\":"\\","\r":"r","\n":"n","\u2028":"u2028","\u2029":"u2029"},V=/\\|'|\r|\n|\u2028|\u2029/g,$=function(n){return"\\"+U[n]};h.template=function(i,n,r){!n&&r&&(n=r),n=h.defaults({},n,h.templateSettings);var t,e=RegExp([(n.escape||J).source,(n.interpolate||J).source,(n.evaluate||J).source].join("|")+"|$","g"),o=0,a="__p+='";i.replace(e,function(n,r,t,e,u){return a+=i.slice(o,u).replace(V,$),o=u+n.length,r?a+="'+\n((__t=("+r+"))==null?'':_.escape(__t))+\n'":t?a+="'+\n((__t=("+t+"))==null?'':__t)+\n'":e&&(a+="';\n"+e+"\n__p+='"),n}),a+="';\n",n.variable||(a="with(obj||{}){\n"+a+"}\n"),a="var __t,__p='',__j=Array.prototype.join,"+"print=function(){__p+=__j.call(arguments,'');};\n"+a+"return __p;\n";try{t=new Function(n.variable||"obj","_",a)}catch(n){throw n.source=a,n}var u=function(n){return t.call(this,n,h)},c=n.variable||"obj";return u.source="function("+c+"){\n"+a+"}",u},h.chain=function(n){var r=h(n);return r._chain=!0,r};var G=function(n,r){return n._chain?h(r).chain():r};h.mixin=function(t){return h.each(h.functions(t),function(n){var r=h[n]=t[n];h.prototype[n]=function(){var n=[this._wrapped];return u.apply(n,arguments),G(this,r.apply(h,n))}}),h},h.mixin(h),h.each(["pop","push","reverse","shift","sort","splice","unshift"],function(r){var t=e[r];h.prototype[r]=function(){var n=this._wrapped;return t.apply(n,arguments),"shift"!==r&&"splice"!==r||0!==n.length||delete n[0],G(this,n)}}),h.each(["concat","join","slice"],function(n){var r=e[n];h.prototype[n]=function(){return G(this,r.apply(this._wrapped,arguments))}}),h.prototype.value=function(){return this._wrapped},h.prototype.valueOf=h.prototype.toJSON=h.prototype.value,h.prototype.toString=function(){return String(this._wrapped)},"function"==typeof define&&define.amd&&define("underscore",[],function(){return h})}();
riot.tag2('asset-picker', '<div class="search-wrap"><input onclick="{fieldClick}" ref="{assetQuery}" onkeyup="{searchChanged}" class="form-field {form-field-open: fieldOpen, has-error: hasError}" placeholder="{control.placeholderText || ⁗Search for an asset⁗}"></input><div class="form-select-list"><div class="form-field form-select" each="{assets}" riot-value="{versionId}" onclick="{chooseAsset}"><div class="form-select-section"><div class="result__img asset__img" riot-style="background-image:url(\'{app.apiUrl}/file/{assetVersionFile.fileId}/thumbnail\');"></div></div><div class="form-select-section"><div class="form-label">Name</div><p class="asset-info"> {name} </p></div></div></div></div><p if="{hasError}" class="form-error-message">field required</p><div class="chosen-assets"><div class="form-field" each="{chosenAssets}"><div class="form-select-section"><div class="result__img asset__img" riot-style="background-image:url(\'{app.apiUrl}/file/{assetVersionFile.fileId}/thumbnail\');"></div></div><div class="form-select-section"><div class="form-label">Name</div><p class="asset-info"> {name} </p></div><div class="form-select-section"><button onclick="{deleteAsset}"><span class="visuallyhidden">Remove</span><i class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 18 18" width="18" height="18"><path d="M3.375 18h11.25V4.5H3.375V18zM4.5 5.625h9v11.25h-9V5.625zM11.25 2.25V0h-4.5v2.25h-4.5v1.125h13.5V2.25h-4.5zm-1.125 0h-2.25V1.125h2.25V2.25z"></path><path d="M6.437 7.875h1.125v6.75H6.437zM10.437 7.875h1.125v6.75h-1.125z"></path></svg></i></button></div></div></div>', '', '', function(opts) {
    this.app = opts.app;
    const app = this.app;
    this.fieldOpen = false;
    this.assets = app.assets;
    this.searchTerm = '';
    this.wifnid = opts.wifnid;
    this.hasError = opts.haserror;

    this.userValues = opts.uservalues;
    this.userValue = opts.uservalue;
    this.userValueArray = opts.uservaluearray;
    this.control = opts.control;
    this.chosenAssets = [];

    if(!utils.isNullOrUndefined(this.userValue.assetId)) {
      for(let i in this.userValueArray) {
        if(!utils.isNullOrUndefined(this.userValueArray[i].assetId)) {
          this.app.getAssetById(this.userValueArray[i].assetId);
        }
      }
    }

    this.outsideClick = (event) => {
      let tooltipElems = document.querySelector('.search-wrap');
      let isClickInside = true;

      if(!utils.isNullOrUndefined(tooltipElems)) {
        isClickInside = tooltipElems.contains(event.target);
      } else {
        isClickInside = false;
      }

      if (!isClickInside) {
        this.fieldOpen = false;
        document.removeEventListener('click', this.outsideClick);
        this.update();
      }
    }

    this.fieldClick = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.fieldOpen = !this.fieldOpen;
      if(this.fieldOpen) {
        if(utils.isNullOrUndefined(this.assets)) {
          app.getAssets(this.searchTerm, this.control.assetTypeId);
        }
        document.addEventListener('click', this.outsideClick);
      }
      this.update();
    }

    this.assetsLoaded = (assets) => {
      this.assets = assets;
      this.update();
    }

    this.assetLoadedById = (asset) => {
      let soughtAfter = false;
      for(let i in this.userValueArray) {
        if(this.userValueArray[i].assetId == asset.versionId) {
          this.chosenAssets.push(asset);
        }
      }
      this.update();
    }

    this.searchChanged = (e) => {
      this.app.getAssets(e.target.value, this.control.assetTypeId);
    }

    this.chooseAsset = (e) => {
      e.preventDefault();
      e.stopPropagation();
      let exists = false;
      for(let i in this.chosenAssets) {
        if(this.chosenAssets[i].versionId == e.item.versionId) {
          exists = true;
        }
      }
      if(!exists) {
        this.chosenAssets.push(e.item);
      }
      this.fieldOpen = false;
      this.chosenAssetsChanged();
      document.removeEventListener('click', this.outsideClick);
    }

    this.chosenAssetsChanged = () => {
      let idsArray = [];
      for(let i in this.chosenAssets) {
        idsArray.push(this.chosenAssets[i].versionId);
      }
      app.multiFieldChanged(this.control.id, idsArray, this.wifnid, 'asset');
      this.update();
    }

    this.deleteAsset = (e) => {
      for(let i in this.chosenAssets) {
        if(this.chosenAssets[i].versionId == e.item.versionId) {
          this.chosenAssets.splice(i, 1);
          this.chosenAssetsChanged();
        }
      }
    }

    this.errorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = true;
        this.update();
      }
    };

    this.noErrorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = false;
        this.update();
      }
    };

    this.on('mount', () => {
      app.on('assetsLoaded', this.assetsLoaded);
      app.on('assetLoadedById', this.assetLoadedById);
      app.on('errorFound', this.errorFound);
      app.on('noErrorFound', this.noErrorFound);
    });

    this.on('unmount', () => {
      app.off('assetsLoaded', this.assetsLoaded);
      app.off('assetLoadedById', this.assetLoadedById);
      app.off('errorFound', this.errorFound);
      app.off('noErrorFound', this.noErrorFound);
    });
});
riot.tag2('content-carousel-item', '<div class="carousel__img"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 186 40.5" width="186" height="40.5"><path fill="#cd040b" d="M181.9 0L172 21.2l-3.8-8h-4.1l6.3 13.1h3.2L186 0z"></path><path d="M139.3 39.7h8.3V25.2c0-3.3 2-5.6 5-5.6 2.8 0 4.4 1.9 4.4 4.7v15.5h8.3V22.7c0-5.7-3.6-9.8-9.4-9.8-3.7 0-6.3 1.5-8.3 4.3h-.1v-3.5h-7.9v26h-.3zM123 12.9c-8.7 0-14.3 5.9-14.3 13.8 0 7.7 5.8 13.8 14.3 13.8 8.7 0 14.3-6 14.3-13.8.2-7.7-5.6-13.8-14.3-13.8zm0 21.8c-3.9 0-5.9-3.2-5.9-8s2-8 5.9-8 6 3.1 6 8c.1 4.8-2.1 8-6 8zm-37.8 5h23.1v-6.3h-13v-.1l12.6-13.6v-6.2H85.3v6.3H98v.2L85.2 33.6v6.1zm-10.5 0H83v-26h-8.3v26zm-19.2 0h8.3v-12c0-5.5 3.4-7.9 8.5-7.2h.1v-6.8c-.5-.1-.9-.2-1.7-.2-3.2 0-5.3 1.4-7.2 4.4h-.1v-4.3h-7.8v26.1h-.1zm-15.2-5c-3.7 0-5.8-2.3-6.3-5.8h19.6c0-5.6-1.4-10-4.7-12.9-2.3-2.1-5.3-3.2-9.1-3.2-8.2 0-13.7 5.9-13.7 13.7 0 7.9 5.3 13.8 14.3 13.8 3.4 0 6-.9 8.3-2.4 2.4-1.6 4-3.9 4.5-6.2h-7.9c-1 1.9-2.6 3-5 3zm-.5-16.1c3 0 4.9 2.1 5.2 5.1H34c.6-3 2.4-5.1 5.8-5.1zM9.4 39.7H18l9.4-26h-8.3l-5.3 16.7h-.1L8.5 13.7H0l9.4 26zM74.7 4.4H83v7.1h-8.3V4.4z"></path></svg></div><div class="carousel__body"><h2 class="carousel__title">Corpus callosum rings of uranus</h2><h3 class="carousel__subtitle">Quasar, across the centuries?</h3><p class="carousel__info">Carousel info. Euclid, courage of our questions? White dwarf, laws of physics. A mote of dust suspended in a sunbeam consciousness rich in heavy atoms radio telescope are creatures of the cosmos trillion?</p></div>', 'content-carousel-item,[data-is="content-carousel-item"]{ display: block; }', 'class="carousel__item"', function(opts) {

    const app = this.opts.app;
    this.app = app;

});
riot.tag2('content-carousel', '<ul class="carousel owl-carousel"><li class="carousel__item" each="{content, index in contents}"><div class="carousel__img"><img riot-src="{content.imageUrl}"></div><div class="carousel__body"><h2 class="carousel__title" if="{content.title}">{content.title}</h2><h3 class="carousel__subtitle" if="{content.subTitle}">{content.subTitle}</h3><div class="carousel__info"><raw-html content="{content.info}"></raw-html></div></div></li></ul>', 'content-carousel,[data-is="content-carousel"]{ display: block; }', '', function(opts) {
    const app = this.opts.app;
    this.app = app;

    this.user = app.getUser();

    this.contents = [
      {imageUrl: 'https://assets.pcmag.com/media/images/477778-new-verizon-logo.jpg?thumb=y&width=810&height=456', title: 'Welcome to Verizon Marketing Builder', subTitle: '', info: '<p>A dynamic marketing request system for Areas and Regions to efficiently customize advertising materials for localized marketing efforts.</p><p><strong>ONE-OFF REQUESTS:</strong> Click the Request tab to submit a one-off request form for approval.</p>'},
      {imageUrl: 'https://assets.pcmag.com/media/images/477778-new-verizon-logo.jpg?thumb=y&width=810&height=456', title: 'Welcome to Your Trade Show Builder', subTitle: '', info: '<p>The Trade Show System will simplify the planning process and enhance the experience for your attendees with sleek, brand-compliant footprints. We currently have two sizes available: 10’x10’and 20’x20’.  Additional sizes will be available later in the year.</p><p>Begin your trade show planning using the "request" link above.</p><p><strong><a target="_blank" href="/images/trade_show_homepage_designs.pdf">Click here</a></strong> to view available footprint designs.</p>'}
    ];

    this.owlInit = () => {
      $(this.root.querySelector('ul')).owlCarousel({
        items: 1,
        loop: true,
        autoplay: true,
        autoplaytimeout: 1000,
        autoplayHoverPause: true,
        nav: true,
        navText: [
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.8 20" width="19.8" height="20"><title>Previous</title><path d="M10.9 19.1l-8.5-8.5h17.4V9.4H2.4L10.9.9 10 0 0 10l10 10 .9-.9z"></path></svg>',
          '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.8 20" width="19.8" height="20"><title>Next</title><path d="M8.9.9l8.5 8.5H0v1.2h17.4l-8.5 8.5.9.9 10-10-10-10z"></path></svg>'
        ]
      });
    };

    this.on('mount', () => {
      this.owlInit();
    });

});
riot.tag2('content-pagination', '<virtual if="{totalPages > 1}"><ul class="inline-list pagination-list"><li class="pagination-start" if="{currentPage > 1}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{0}"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 15 12" width="15" height="12"><path d="M7 6.1L12.3.7l.7.7-4.6 4.7 4.6 4.6-.7.7L7 6.1z"></path><path d="M8 10.7l-.7.7L2 6.1 7.3.7l.7.7-4.6 4.7"></path></svg></button></li><li class="pagination-prev" if="{currentPage > 0}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{currentPage - 1}"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 10 12" width="10" height="12"><path d="M2.1 6L7.4.6l.7.8L3.5 6l4.6 4.6-.7.7L2.1 6z"></path></svg></button></li><li class="pagination-page {active: num === currentPage}" each="{num in leadUp}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{num}">{num + 1}</button></li><virtual if="{tailNeeded}"><li class="pagination-page" if="{totalPages > minNumForDots}"><p class="pagination-link">...</p></li></virtual><virtual if="{currentPage != totalPages - 1}"><li class="pagination-page {active: (totalPages - 1) === currentPage}" if="{totalPages > minNumForDots}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{totalPages - 1}">{totalPages}</button></li></virtual><li class="pagination-next" if="{currentPage < totalPages - 1}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{nextPage}"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 10 12" width="10" height="12"><path d="M2.8 11.3l-.7-.7L6.7 6 2.1 1.4l.7-.8L8.1 6z"></path></svg></button></li><li class="pagination-end" if="{currentPage < totalPages - 2}"><button class="pagination-link" onclick="{pageClicked}" riot-value="{totalPages - 1}"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 15 12" width="15" height="12"><path d="M2.7 11.4l-.7-.7L6.6 6 2 1.4l.7-.8L8 6.1l-5.3 5.3z"></path><path d="M11.6 6.1L7 1.4l.7-.8L13 6.1l-5.3 5.3-.7-.7"></path></svg></button></li></ul></virtual>', '', 'class="pagination"', function(opts) {
    this.app = opts.app;

    this.currentPage = this.app.currentPage;
    this.nextPage = parseInt(this.currentPage) + 1;
    this.totalPages = this.app.totalPages;

    this.prevDots = true;
    this.postDots = false;

    this.minNumForDots = 6;
    this.tailNeeded = true;

    this.getLeadup = () => {
      if(this.totalPages <= this.minNumForDots) {
        this.leadUp = [];
        for(let i = 0; i < this.totalPages; i++) {
          this.leadUp.push(i);
        }
      } else if(this.currentPage < 4) {
        this.leadUp = [0,1,2,3];
      } else {
        this.leadUp = [(this.currentPage - 3),
          (this.currentPage - 2),
          (this.currentPage - 1),
          (parseInt(this.currentPage))];
        this.tailNeeded = this.currentPage < this.totalPages - 2;
      }
    };

    this.getLeadup();

    this.pageClicked = (e) => {
      this.currentPage = e.target.value;
      this.app.pageChange(parseInt(e.target.value, 10));
    };

    this.sortChanged = () => {
      this.currentPage = this.app.currentPage;
      this.nextPage = parseInt(this.currentPage) + 1;
      this.totalPages = this.app.totalPages;
      this.getLeadup();
      this.update();
    };

    this.on('mount', () => {
      this.app.on('sortChanged', this.sortChanged);
    });

    this.on('unmount', () => {
      this.app.off('sortChanged', this.sortChanged);
    });
});

riot.tag2('content-revealer', '<p class="revealer-open intro" onclick="{reveal}">{opts.title} <i class="revealer-icon icon"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 18 18" width="18" height="18"><path if="{!showrevealer}" id="v" d="M8.5 0h1v18h-1z"></path><path id="h" d="M0 9.5v-1h18v1z"></path></svg></i></p><div class="revealer-body" if="{showrevealer}"><yield></yield></div>', '', 'class="revealer {\'is-active\': showrevealer}"', function(opts) {

    this.showrevealer = false;

    if (this.opts.hasOwnProperty('startOpen')) {
      this.showrevealer = true;
    }

    this.reveal = function() {
      this.showrevealer = !this.showrevealer;
    }.bind(this)

});
riot.tag2('custom-dropdown', '<div class="{has-error: hasError}"><label for="{nameId}" class="form-label {inline-label: opts.inline}">{opts.label} </label><select name="{nameId}" id="{nameId}" placeholder="{placeholder}"><virtual if="{!opts.options}"><yield></yield></virtual><option if="{!isSorter}" value="null">select one</option><option each="{choices}" riot-value="{id}" selected="{id == selectedId}">{value}</option></select><p if="{hasError}" class="form-error-message">field required</p></div>', '', '', function(opts) {
    const app = this.opts.app;
    this.app = app;
    this.choices = this.opts.choices;
    this.control = this.opts.control;
    this.userValue = this.opts.uservalue;
    this.isselected = this.opts.isselected;
    this.wifnid = this.opts.wifnid;
    this.hasError = this.opts.haserror;

    this.isSorter = this.opts.issorter;
    this.sorterType = this.opts.sortertype;

    if(this.sorterType == 'status') {
      if(!utils.isNullOrUndefined(this.choices)) {
        for(let i = 0; i < this.choices.length; i++) {
          this.choices[i].value = this.choices[i].name;
        }
      }
    }

    if(!utils.isNullOrUndefined(this.control)) {
      this.placeholder = this.control.placeholderText;
      this.nameId =
        `${this.control.type}-${this.control.subtype}-${this.control.id}`;
    }

    this.selectionChanged = (value) => {
      if(!utils.isNullOrUndefined(this.control)) {
        let selectionObj = {
          controlId: this.control.id,
          controlValue: value
        };
        app.fieldChanged(selectionObj, this.wifnid);
        this.userValue.controlValue = value;
      } else if(this.isSorter) {
        this.app.sortChanged(this.sorterType, value);
      }
    }
    if(!utils.isNullOrUndefined(this.userValue)) {
      if(!utils.isNullOrUndefined(this.userValue.controlValue)) {
        this.selectedId = this.userValue.controlValue;
      }
    }

    if(!utils.isNullOrUndefined(this.isselected)) {
      this.selectedId = this.isselected;
      this.selectionChanged(this.selectedId);
    }

    const toggleSelected = ($dropdown) => {

      let ival = this.root.querySelector('.item').getAttribute('data-value');

      let opts = $dropdown[0].querySelectorAll('.option');

      for (let i=0;i<opts.length;i++) {

        if (opts[i].getAttribute('data-value') !== ival) {

          opts[i].classList.remove('is-selected');
        } else {

          opts[i].classList.add('is-selected');
        }
      }
    };

    this.on('mount', () => {
      const options = opts.options;
      const s = $(this.root.querySelector('select')).selectize({
        onDropdownOpen: toggleSelected,
        onChange: this.selectionChanged,
        valueField: 'id',
        labelField: 'text',
        options: options,
        placeholder: this.placeholder
      });
    });

    this.errorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = true;
        this.update();
      }
    }

    this.noErrorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = false;
        this.update();
      }
    }

    this.on('mount', () => {
      app.on('errorFound', this.errorFound);
      app.on('noErrorFound', this.noErrorFound);
    });

    this.on('unmount', () => {
      app.off('errorFound', this.errorFound);
      app.off('noErrorFound', this.noErrorFound);
    });
});

riot.tag2('custom-image-upload', '<div class="upload-field {show-loader: showLoader, has-error: hasError}"><input type="file" name="Choose File" id="Choose File" class="visuallyhidden" ref="fileInput" onchange="{uploadFile}"><label for="Choose File" class="custom-file xsmall-button white-button">Choose File</label><span id="Info" class="custom-file-label">{spanLabel}</span><div class="loader js-playlist-loader"><span class="loader-1"></span><span class="loader-2"></span><span class="loader-3"></span></div></div><p if="{hasError}" class="form-error-message">field required</p>', 'custom-image-upload,[data-is="custom-image-upload"]{ display: block; }', '', function(opts) {
    this.app = opts.app;
    this.spanLabel = opts.label;
    this.control = opts.control;
    this.userValueArray = opts.uservaluearray;
    this.wifnid = opts.wifnid;
    this.hasError = opts.haserror;

    if(!utils.isNullOrUndefined(this.userValueArray)) {
      if(this.userValueArray.length) {
        this.app.getFiles(0, 100);
      }
    }

    this.uploadFile = () => {
      let file = this.refs[`fileInput`].files[0];
      let name = file.name;
      this.spanLabel = name;
      this.app.uploadNewFile(file, this.control.id, this.wifnid);
      this.update();
    };

    this.fileListLoaded = (fileList) => {
      if(!utils.isNullOrUndefined(this.userValueArray)) {
        for(let i in fileList) {
          if(fileList[i].versionId == this.userValueArray[0].fileId) {
            this.spanLabel = fileList[i].name;
            this.update();
          }
        }
      }
    };

    this.fileUploading = () => {
      this.showLoader = true;
      this.update();
    };

    this.fileUploaded = () => {
      this.showLoader = false;
      this.update();
    };

    this.errorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = true;
        this.update();
      }
    };

    this.noErrorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = false;
        this.update();
      }
    };

    this.on('mount', () => {
      this.app.on('fileListLoaded', this.fileListLoaded);
      this.app.on('fileUploading', this.fileUploading);
      this.app.on('fileUploaded', this.fileUploaded);
      this.app.on('errorFound', this.errorFound);
      this.app.on('noErrorFound', this.noErrorFound);
    });

    this.on('unmount', () => {
      this.app.off('fileListLoaded', this.fileListLoaded);
      this.app.off('fileUploading', this.fileUploading);
      this.app.off('fileUploaded', this.fileUploaded);
      this.app.off('errorFound', this.errorFound);
      this.app.off('noErrorFound', this.noErrorFound);
    });
});
riot.tag2('custom-multi-dropdown', '<div class="{has-error: hasError}"><label for="{nameId}" class="form-label block-label visuallyhidden">{label}</label><select name="{nameId}" id="{nameId}" multiple placeholder="{placeholder}"><virtual if="{!opts.options}"><yield></yield></virtual></select></div><p if="{hasError}" class="form-error-message">field required</p>', 'custom-multi-dropdown,[data-is="custom-multi-dropdown"]{ display: block; }', '', function(opts) {
    const app = this.opts.app;
    this.app = app;
    this.control = this.opts.control;
    this.userValues = this.opts.uservalues;
    this.controlValuesArray = [];
    this.wifnid = this.opts.wifnid;
    this.hasError = this.opts.haserror;
    this.userValueArray = this.opts.uservaluearray;

    if(!utils.isNullOrUndefined(this.userValues)) {
      for(let i = 0; i < this.userValues.length; i++) {
        if(this.userValues[i].controlId == this.control.id) {
          this.controlValuesArray.push(this.userValues[i].controlValue);
        }
      }
    }

    this.options = this.opts.options;

    if(!utils.isNullOrUndefined(this.control)) {
      this.placeholder = this.control.placeholderText;
      this.label = this.control.label;
      this.nameId =
        `${this.control.type}-${this.control.subtype}-${this.control.id}`;
    }

    this.itemChanged = (itemsArray) => {
      app.multiFieldChanged(this.control.id, itemsArray, this.wifnid);
      this.controlValuesArray = itemsArray;
      this.userValueArray = [];
      for(let i in itemsArray) {
        this.userValueArray.push({
          controlId: this.control.id,
          controlValue: itemsArray[i]
        })
      };
    }

    this.on('mount', () => {
      const options = this.options;
      const s = $(this.root.querySelector('select')).selectize({
        plugins: ['remove_button'],
        valueField: 'id',
        labelField: 'value',
        create: false,
        options: options,
        onChange: this.itemChanged
      })[0].selectize;
      s.setValue(this.controlValuesArray);
    });

    this.errorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = true;
        this.update();
      }
    }

    this.noErrorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = false;
        this.update();
      }
    }

    this.on('mount', () => {
      app.on('errorFound', this.errorFound);
      app.on('noErrorFound', this.noErrorFound);
    });

    this.on('unmount', () => {
      app.off('errorFound', this.errorFound);
      app.off('noErrorFound', this.noErrorFound);
    });

});
riot.tag2('date-picker', '<input class="form-field {has-error: hasError}" type="text" riot-value="{formatValue()}" onfocus="{focus}" onblur="{blur}" onchange="{change}"><div class="picker" hide="{!showPicker}" onmousedown="{pickerClick}"><div class="monthSelector"><div><button class="triangle-symbol {disabled: monthOffset == 0}" onclick="{prevMonth}">{opts.prevButton || \'◀\'}</button><div class="currMonth">{months[currentMonth]}</div><button class="triangle-symbol" onclick="{nextMonth}">{opts.nextButton || \'▶\'}</button></div><div><button class="triangle-symbol {disabled: monthOffset == 0}" onclick="{prevYear}">{opts.prevButton || \'◀\'}</button><div class="currYear">{currentYear}</div><button class="triangle-symbol" onclick="{nextYear}">{opts.nextButton || \'▶\'}</button></div></div><table><thead><tr><th each="{weekday in weekdays}">{weekday}</th></tr></thead><tbody><tr each="{row in rows}"><td class="{cur: d.getMonth() == currentMonth,                    selected: d.valueOf() === value.valueOf(),                    today: d.getDate() === today.getDate(),                    disabled: dateIsDisabled(d)}" each="{d in row}" onclick="{setValueClick}"> {d.getDate()} </td></tr></tbody></table></div><p if="{hasError}" class="form-error-message">field required</p>', '', '', function(opts) {
    const app = this.opts.app;
    this.app = app;
    this.isDateRange = this.opts.isdaterange;
    this.control = this.opts.control;
    this.hasError = this.opts.haserror;
    this.userValue = this.opts.uservalue;
    this.wifnid = this.opts.wifnid;
    this.startValue = this.opts.value;
    this.noUserValue = true;
    this.today = new Date();
    this.disabledDateRanges = this.control.disabledDateRanges;

    this.dateChange = (date, isOnLoad) => {
      if(!utils.isNullOrUndefined(this.isDateRange)) {
        if(this.isDateRange == 'start') {

          this.userValue.value = date + '|' + this.userValue.endDate;
          this.userValue.startDate = date;
        } else {
          this.userValue.value = this.userValue.startDate + '|' + date;
          this.userValue.endDate = date;
        }
      } else {
        this.userValue.value = date;
      }
      if(!isOnLoad || this.noUserValue) {
        app.dateChange(this.isDateRange, this.formattedDate,
          this.control.id, this.wifnid);
      }
    };

    this.formattedDate = new Date().toISOString();

    const setValue = (val) => {
      this.value = new Date(val);

      if(isNaN(this.value.valueOf() ) ) {
        this.value = new Date();
      }
    };

    if(!utils.isNullOrUndefined(this.userValue.value)) {
      this.noUserValue = false;
      if(utils.isNullOrUndefined(this.isDateRange)) {
        this.formattedDate = this.userValue.value;
      } else {
        if(this.isDateRange == 'start') {
          if(!utils.isNullOrUndefined(this.userValue.startDate)) {
            this.formattedDate = this.userValue.startDate;
          }
        } else {
          if(!utils.isNullOrUndefined(this.userValue.endDate)) {
            this.formattedDate = this.userValue.endDate;
          }
        }
      }
    }

    setValue(this.formattedDate);

    this.formatValue = typeof opts.formatValue === "function" ?
      opts.formatValue : () => {

      if(dateFns.isEqual(this.value, this.today)) {
        return ('MM/DD/YYYY');
      }
      return dateFns.format(this.value, 'M/D/YYYY');
    };

    let d = new Date("1/1/2017");
    this.months = new Array(12);

    for (let i = 0; i < 12; i++) {
      d.setMonth(i);

      this.months[i] = dateFns.format(d, (opts.monthFormat || 'MMMM'));
    }

    d = new Date("1/1/2017");
    this.weekdays = new Array(7);
    for (let i = 0; i < 7; i++) {

      this.weekdays[i] = dateFns.format(d, (opts.weekdayFormat || 'ddd'));
      d.setDate(d.getDate() + 1);
    }

    this.monthOffset = 0;

    this.showPicker = false;

    this.dateIsDisabled = (date) => {
      if(dateFns.isBefore(date, this.today) ||
         dateFns.isEqual(date, this.today)) {
        return true;
      }
      if(!utils.isNullOrUndefined(this.disabledDateRanges)) {
        for(let i in this.disabledDateRanges) {
          let begin = this.disabledDateRanges[i].begin;
          let end = this.disabledDateRanges[i].end;
          if((dateFns.isBefore(date, end) && dateFns.isAfter(date, end)) ||
             (dateFns.isEqual(date, end) || dateFns.isEqual(date, end))){
            return true;
          }
        }
      }
    }

    this.focus = (e) => {
      if(this.showPicker) {
        e.preventUpdate = true;
      } else {
        this.showPicker = true;
      }
    };

    this.pickerClick = (e) => {
      this.abortBlur = true;
      e.preventUpdate = true;
    };

    this.blur = (e) => {
      if(this.abortBlur) {
        e.currentTarget.focus();
        this.abortBlur = false;
        e.preventUpdate = true;
      } else {
        this.showPicker = false;
        this.monthOffset = 0;
      }
    };

    this.change = (e) => {
      setValue(e.currentTarget.value);

      this.monthOffset = 0;

      e.currentTarget.value = this.formatValue(this.value);
    };

    this.setValueClick = (e) => {
      this.value = e.item.d;
      this.monthOffset = 0;
      this.formattedDate = e.item.d.toISOString();
      this.dateChange(this.formattedDate);

      if (e.item.d && e.type == 'click') {

        this.showPicker = false;

        this.root.querySelector('input').blur();
      }
    };

    this.prevMonth = (e) => {
      e.preventDefault();
      this.monthOffset--;
    };

    this.nextMonth = (e) => {
      e.preventDefault();
      this.monthOffset++;
    };

    this.prevYear = (e) => {
      e.preventDefault();
      this.monthOffset -= 12;
      if(this.monthOffset < 0) {
        this.monthOffset = 0;
      }
    };

    this.nextYear = (e) => {
      e.preventDefault();
      this.monthOffset += 12;
    };

    this.on("update", () => {
      let d = new Date(this.value);

      d.setDate(1);

      d.setMonth(d.getMonth() + this.monthOffset);
      this.currentMonth = d.getMonth();
      this.currentYear = d.getFullYear();

      d.setDate(d.getDate() - d.getDay() );

      let row = [];
      this.rows = [row];

      for(let i = 0; i < 7; i++) {
        row.push(new Date(d));
        d.setDate(d.getDate() + 1);
      }

      while (this.currentMonth === d.getMonth() ) {
        row = [];
        for(let i = 0; i < 7; i++) {
          row.push(new Date(d));
          d.setDate(d.getDate() + 1);
        }
        this.rows.push(row);
      }
    });

    this.errorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = true;
        this.update();
      }
    }

    this.noErrorFound = (controlId) => {
      if(this.control.id == controlId) {
        this.hasError = false;
        this.update();
      }
    }

    this.on('mount', () => {
      app.on('errorFound', this.errorFound);
      app.on('noErrorFound', this.noErrorFound);
    });

    this.on('unmount', () => {
      app.off('errorFound', this.errorFound);
      app.off('noErrorFound', this.noErrorFound);
    });

});

riot.tag2('date-range', '<div class="custom-date-range"><span class="custom-date-range-field"><date-picker app="{app}" control="{control}" uservalue="{userValue}" haserror="{hasError}" wifnid="{wifnid}" riot-value="{\'2018-08-03T19:15:56.048Z\'}" isdaterange="start"></date-picker></span><span class="custom-date-range-icon icon"><span class="visuallyhidden">Icon: Line</span><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 16 1" width="16" height="1"><path d="M0 0h16v1H0V0z"></path></svg></span><span class="custom-date-range-field"><date-picker app="{app}" control="{control}" uservalue="{userValue}" haserror="{hasError}" isdaterange="end" wifnid="{wifnid}"></date-picker></span></div>', 'date-range,[data-is="date-range"]{ display: block; position: relative; }', '', function(opts) {
    const app = this.opts.app;
    this.app = app;
    this.control = this.opts.control;
    this.hasError = this.opts.haserror;
    this.userValue = this.opts.uservalue;
    this.wifnid = this.opts.wifnid;

    if(!utils.isNullOrUndefined(this.userValue.value)) {

        let dateRangeArray = this.userValue.value.split('|');
        this.userValue.startDate = dateRangeArray[0];
        this.userValue.endDate = dateRangeArray[1];

    }
});
riot.tag2('message-bar', '<div if="{showAlert}" class="message-bar {color}"><div class="message"> {message} </div></div>', '', '', function(opts) {
var _this = this;

var app = this.opts.app;

this.alert = function (msg) {
  _this.message = msg.message;
  _this.showAlert = true;

  switch (msg.type) {
    case 'success':
      _this.color = "message-bar-success";
      break;

    case 'error':
      _this.color = "message-bar-error";
      break;
  }

  setTimeout(function () {
    _this.showAlert = false;

    _this.update();
  }, 2000);

  _this.update();
};

this.on('mount', function () {
  _this.showAlert = false;
  app.on('alert', _this.alert);
});
this.off('unmount', function () {
  _this.showAlert = false;
  app.off('alert', _this.alert);
});
});
riot.tag2('modal-confirm-popup', '<button onclick="{click}" class="{button: isprimary, white-button: isprimary && index > 0,       link: !isprimary}"><span>{action.name}</span></button><div class="modal-bg" if="{showmodal}"></div><div class="modal" if="{showmodal}"><button class="modal-close icon" onclick="{click}"><span class="visuallyhidden">Icon: X close</span><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 18 18" width="18" height="18"><switch><path d="M17.272 1.522l-.794-.794L9 8.205 1.522.728l-.794.794L8.205 9 .728 16.478l.794.794L9 9.795l7.478 7.477.794-.794L9.795 9z"></path></switch></svg></button><div class="modal-header"><h2 class="modal-title">Confirmation required</h2><p class="modal-info intro">Please confirm the action you are about to take on this project.</p></div><div class="modal-body"><label class="form-label block-label">Comment</label><textarea class="form-field" rows="10" onkeyup="{commentChange}" ref="commentTxt">{comment}</textarea></div><div class="modal-controls button-group"><button class="button white-button" onclick="{click}">Cancel</button><button class="button" onclick="{validateForm}">{action.name}</button></div></div>', '', '', function(opts) {
    const app = this.opts.app;
    this.app = app;
    this.action = this.opts.action;
    this.index = this.opts.index;
    this.isprimary = this.opts.isprimary;
    this.comment = app.model.comment;

    this.showmodal = false;

    this.click = (event) => {
      this.showmodal = !this.showmodal;
      this.comment = app.model.comment;
    }

    this.commentChange = () => {
      app.commentChange(this.action.id, this.refs.commentTxt.value);
    }

    this.validateForm = () => {
      app.validateForm(this.action.id, this.action.validate);
    }

});
riot.tag2('modal-popup', '<button onclick="{click}"><yield from="icon"></yield></button><div class="modal-bg" if="{showmodal}"></div><div class="modal" if="{showmodal}"><button class="modal-close icon" onclick="{click}"><span class="visuallyhidden">Icon: X close</span><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 18 18" width="18" height="18"><switch><path d="M17.272 1.522l-.794-.794L9 8.205 1.522.728l-.794.794L8.205 9 .728 16.478l.794.794L9 9.795l7.478 7.477.794-.794L9.795 9z"></path></switch></svg></button><div class="modal-header"><h2 class="modal-title headline">{title}</h2><p class="modal-info intro">{info}</p></div><div class="modal-body"><yield from="body"></yield></div><div class="modal-controls button-group"><button class="white-button" onclick="{click}">Cancel</button><button class="button">Build</button></div></div>', '', '', function(opts) {

    this.title = 'This is modal title. Cambrian explosion! Are creatures of the cosmos.';
    this.info = 'This is modal info. Ship of the imagination. Intelligent beings from which we spring. Rogue a very small stage in a vast cosmic arena at the edge of forever billions upon billions.';

    this.showmodal = false;

    this.click = (event) => {
      this.showmodal = !this.showmodal;
    }

});
riot.tag2('prompt-modal', '<div style="display: none;"><yield></yield></div><virtual if="{active}"><div class="modal-bg"></div><div class="modal"><button class="modal-close icon" onclick="{cancelClick}"><span class="visuallyhidden">Icon: X close</span><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 18 18" width="18" height="18"><switch><path d="M17.272 1.522l-.794-.794L9 8.205 1.522.728l-.794.794L8.205 9 .728 16.478l.794.794L9 9.795l7.478 7.477.794-.794L9.795 9z"></path></switch></svg></button><div class="modal-header"><h2 class="modal-title headline">{headline}</h2><p class="modal-info intro">{intro}</p></div><div ref="modalContent" class="modal-body"><yield from="body"></yield></div><div class="modal-controls button-group"><button each="{button in buttons}" onclick="{buttonClick}" class="{button.type}"> {button.text} </button></div></div></virtual>', 'prompt-modal,[data-is="prompt-modal"]{ display: block; }', '', function(opts) {
    this.headline = opts.headline || 'Are you sure?';
    this.intro = opts.intro || 'This action can\'t be undone.';
    this.active = !!opts.showmodal;
    this.onChoice = opts.onchoice || null;
    this.buttons = [
      { value: 'cancel', text: 'Cancel', type: 'white-button' },
      { value: 'confirm', text: 'Confirm', type: 'button' }
    ];

    this.on('mount', () => {

      const optionList = this.root.querySelectorAll('option');
      if (optionList.length > 0) {
        this.buttons = [];
        for (let i = 0; i < optionList.length; ++i) {
          const opt = optionList[i];

          const b = {
            value: opt.value,
            text: opt.textContent,
            type: opt.getAttribute('type') || 'button'
          };
          this.buttons.push(b);
        }
      }
    });

    this.buttonClick = (e) => {
      e.preventDefault();
      this.active = false;
      if (!utils.isNullOrUndefined(this.onChoice)) {
        this.onChoice(e, e.item.button.value);
      }
    };

    this.cancelClick = (e) => {
      e.preventDefault();
      this.active = false;
      if (!utils.isNullOrUndefined(this.onChoice)) {
        this.onChoice(e, 'close');
      }
    };

});
riot.tag2('raw-html', '', '', '', function(opts) {

    this.html = this.opts.content;
    this.root.innerHTML = this.html;

});
riot.tag2('toast-notification', '<div each="{toast in toasts}" class="toast-message toast-{toast.type}"> {toast.message} </div>', '', 'class="toast-container toast-top-right"', function(opts) {
var _this = this;

var app = this.opts.app;
this.toasts = [];

this.toast = function (toast) {
  _this.toasts.push(toast);

  _this.update();

  setTimeout(function () {
    return _this.removeToast(toast);
  }, 6000);
};

this.removeToast = function (toast) {
  var index = _this.toasts.indexOf(toast);

  _this.toasts.splice(index, 1);

  _this.update();
};

this.on('mount', function () {
  app.on('toast', _this.toast);
});
this.on('unmount', function () {
  app.off('toast', _this.toast);
});
});
riot.tag2('tool-tip', '<button title="View all {opts.title}" onclick="{click}"><yield from="icon"></yield></button><div if="{showtooltip}" class="tooltip" onclick="{onTooltipClick}"><button onclick="{click}" class="tooltip-close"><svg xmlns="http://www.w3.org/2000/svg" viewbox="0 0 18 18" width="18" height="18"><switch><path d="M17.272 1.522l-.794-.794L9 8.205 1.522.728l-.794.794L8.205 9 .728 16.478l.794.794L9 9.795l7.478 7.477.794-.794L9.795 9z"></path></switch></svg></button><h4>{opts.title}</h4><ul class="tooltip-info"><li each="{user, index in users}"><span if="{user.firstName && user.lastName}">{user.firstName} {user.lastName}</span><span if="{!user.firstName || !user.lastName}" show="{index > 2}">{user}</span></li></ul></div>', 'tool-tip,[data-is="tool-tip"]{ position: relative; }', '', function(opts) {
    this.app = opts.app;
    this.users = this.opts.users;

    this.showtooltip = false;
    this.tooltipID = -1;

    this.on('mount', () => {
      this.tooltipID = TooltipController.instance.registerTooltip();
      TooltipController.instance.on('activeTooltipChanged', this.tooltipOpened);
    });

    this.on('unmount', () => {
      window.tooltipController.off('activeTooltipChanged', this.tooltipOpened);
    });

    this.tooltipOpened = (id) => {
      if (this.tooltipID !== id && this.showtooltip === true) {
        this.showtooltip = false;
        this.update();
      }
    };

    this.outsideClick = (event) => {
      let tooltipElems = document.querySelector('.tooltip');
      let isClickInside = true;

      if(!utils.isNullOrUndefined(tooltipElems)) {
        isClickInside = tooltipElems.contains(event.target);
      } else {
        isClickInside = false;
      }

      if (!isClickInside) {
        this.tooltipOpened(null);
        document.removeEventListener('click', this.outsideClick);
      }
    };

    this.click = (e) => {
      e.preventDefault();
      e.stopPropagation();
      this.showtooltip = !this.showtooltip;

      if (this.showtooltip) {
        window.tooltipController.showTooltip(this.tooltipID);
        document.addEventListener('click', this.outsideClick);
      }

      this.update();
    };

    this.onTooltipClick = (e) => {
      e.stopPropagation();
    };

});